const serviceTerm = {
  ko:
    '<h4>이용약관</h4>' +
    '<div>' +
    '• 본 이용약관은 2023년 7월 21일부터 효력이 발생합니다.' +
    '<br>' +
    '• [2024년 10월 21일] 제19조(사용제한조치) - 포인트 사용 제한 조항 추가' +
    '<br>' +
    '• [2025년 5월 1일] 서비스 운영 주체 변경 : 글로브웨이브 주식회사 → 주식회사 딜리버드로지스틱스' +
    '<br><br><br>' +
    '제1조(목적)' +
    '<br><br>' +
    '본 약관은 주식회사 딜리버드로지스틱스(이하 "회사"라 한다)가 제공하는 온라인 마켓플레이스 중개서비스 및 온라인 마켓플레이스 서비스를 이용함에 있어 회사와 회원의 권리와 의무 및 책임사항을 규정하는 것을 목적으로 합니다.' +
    '<br><br><br>' +
    '제2조(정의)' +
    '<br><br>' +
    '본 계약에서 사용되는 용어의 정의는 다음과 같으며, 본 계약에서 정의되지 않은 용어의 해석은 서비스 애플리케이션 내에 제공되는 관련 법률 및 별도의 지침에 따라 적용됩니다:' +
    '<br><br>' +
    'a. "서비스"는 온라인 마켓플레이스 중개 서비스, 온라인 마켓플레이스 서비스, 커뮤니티 참여, 팬 투표 및 회사가 제공하는 기타 서비스를 의미하며, 회원 약관에 동의한 회원은 전자 시스템에 접속하여 온라인 거래를 할 수 있습니다.' +
    '<br><br>' +
    'b. "사이트"는 회사가 운영하는 온라인 상점(https://www.giftifan.com)을 말하며, 컴퓨터 및 정보 통신 시설을 사용하여 회원에게 상품, 서비스 또는 기타 제공물을 거래에 제공합니다. 여기에는 회사가 운영하는 웹 사이트, 모바일 웹 및 애플리케이션이 포함됩니다.' +
    '<br><br>' +
    'c. "회원"은 회사의 응용 프로그램을 다운로드하여 본 약관에 동의하고 서비스 계약을 체결한 후 서비스에 적절하게 가입하는 사용자를 말합니다.' +
    '<br><br>' +
    'd. "아이템스토어"는 회원들이 물품을 구매할 수 있는 공간을 말합니다. 회사에서 운영하는 온라인 쇼핑몰입니다.' +
    '<br><br>' +
    'e. "상품"은 앱에서 사용되는 온라인 상품을 의미하며, 서비스 화면에 유통기한 및 제한사항에 대한 자세한 내용이 표시됩니다.' +
    '<br><br>' +
    'f. "사용자 정보"란 서비스 품질 유지에 필요한 정보(닉네임, 이메일)를 말합니다.' +
    '<br><br>' +
    'g. "포인트"란 사이트에서 상품등의 구매 등에 사용할 수 있는 결제수단으로서, 회원이 대가를 지급하고 구매한 "유상포인트"와 회사가 이벤트·프로모션 등을 통하여 무상으로 지급한 "무상포인트"로 구분된다.' +
    '<br><br><br>' +
    '제3조(약관의 효력)' +
    '<br><br>' +
    '회사는 본 약관에 규정되지 않은 세부적인 사항을 보완하고 운영하기 위해 개별 정책(이하 "정책"이라 한다)을 포함한 별도의 정책을 수립할 수 있습니다. 회사는 해당 정책을 웹사이트를 통해 게시할 예정입니다. 정책은 본 약관과 함께 서비스 약관(이하 "서비스 약관"이라 한다)의 일부를 구성합니다. 본 약관 및 정책에 대한 회원의 동의는 서비스 약관에 서명한 것과 동일한 효력을 갖습니다.' +
    '<br><br>' +
    '회사는 특정 서비스에 대한 약관(이하 "개별약관"이라 한다)을 별도로 제정할 수 있습니다. 회원이 개별약관에 동의하는 경우 서비스 약관의 일부를 구성합니다. 개별약관과 본 약관이 충돌하는 경우 개별약관이 적용됩니다.' +
    '<br><br><br>' +
    '제4조(약관의 공표 및 개정)' +
    '<br><br>' +
    '회사는 본 약관의 내용은 물론 상호, 대표자명, 사업자주소, 전화번호, 이메일주소, 사업자등록번호 등을 웹사이트 초기 서비스 화면에 게시하여 회원이 쉽게 이용할 수 있도록 하여야 합니다. 회사는 홈페이지 내의 링크된 화면을 통해 회원이 본 약관에 쉽게 접근하고 검토할 수 있도록 하여야 합니다.' +
    '<br><br>' +
    '회사는 관련 법규를 위반하지 않는 범위 내에서 본 약관 및 정책을 수정할 수 있습니다. 이 경우 회사는 시행일 7일 전부터 시행일 전일까지 홈페이지를 통해 수정된 내용 및 시행일을 공지합니다. 다만, 제안된 변경사항이 회원에게 불리한 경우 시행일 30일 전부터 시행일까지 수정된 약관 및 정책을 공지합니다.' +
    '<br><br>' +
    '회사는 관련 법령의 변경으로 인해 본 약관 또는 정책이 변경되는 등 긴급하고 부득이한 사정으로 본문에서 정하는 바에 따라 고지하기 어려운 경우 제1항 본문과 동일한 방법으로 시행일 전까지 개정 약관 또는 정책을 공표합니다.' +
    '<br><br>' +
    '회원은 개정 약관 및 정책에 동의하지 아니하는 경우 적용일자 전일까지 거부 의사를 표시하고 이용계약을 해지할 수 있습니다. 이 경우 미사용 유상포인트 등 회원의 권리는 제15 및 제 17조에 따라 정산·환불합니다.' +
    '<br><br>' +
    '회사가 본조에 따라 개정된 약관 또는 정책을 공표 또는 고지하고, 시행일 이전에 회원이 의사표시를 하지 않는 경우에는 개정된 약관 또는 정책에 동의한 것으로 간주됩니다.' +
    '<br><br>' +
    '개정 약관은 그 적용일자 이전으로 소급하여 적용되지 아니합니다. 다만 회원에게 유리한 경우에는 그러하지 아니합니다.' +
    '<br><br>' +
    '본 약관에서 정하지 아니한 내용과 본 약관의 해석에 관하여는 「전자상거래 등에서의 소비자보호에 관한 법률」, 「약관의 규제에 관한 법률」, 공정거래위원회가 정하는 「전자상거래 등에서의 소비자보호 지침」 및 관계법령 또는 상관례에 따릅니다.' +
    '<br><br><br>' +
    '제5조(업무의 제공 및 정지)' +
    '<br><br>' +
    '본 약관에 따라 회사가 제공하는 서비스의 종류는 다음과 같습니다:' +
    '<br>' +
    '• 온라인 상거래 서비스 및 기타 관련 서비스.' +
    '<br>' +
    '• 온라인 상거래 중개 서비스 및 기타 관련 서비스.' +
    '<br>' +
    '• 위 서비스의 제공에 필요하거나 이와 관련된 부가서비스.' +
    '<br><br>' +
    '서비스는 일반적으로 24시간 365일 제공됩니다. 단, 회사는 컴퓨터 등 정보통신설비의 보수점검·교체·고장, 통신두절, 업무상 또는 기술상의 어려움, 기술적 개선 또는 운영상 상당한 이유가 있는 경우 서비스의 제공을 일시적 혹은 영구적으로 중단할 수 있으며, 웹사이트를 통해 변경사항을 안내할 예정입니다.' +
    '<br><br>' +
    '회사는 제2항의 규정에도 불구하고 서비스를 특정 범위로 구분하여 각 범위별로 별도의 운영시간을 지정할 수 있습니다. 이 경우 자세한 내용은 홈페이지를 통해 공지할 예정입니다.' +
    '<br><br>' +
    '사업부문의 변경, 사업종료, 폐업, 합병, 분할, 사업양도, 그 밖의 사유로 회사가 서비스를 제공할 수 없는 경우 회사는 관련 법령을 준수합니다. 해당 관련 법령에서 별도로 규정하지 않는 한 회원에게는 별도의 보상이 제공되지 않습니다.' +
    '<br><br><br>' +
    '제6조(회원가입)' +
    '<br><br>' +
    '사용자는 무료로 회원으로 가입할 수 있으며, 회사가 정한 가입 양식에 회원정보를 기입한 후 본 약관과 개인정보의 수집, 제공 및 활용에 동의한다는 의사표시를 함으로써 회원가입을 신청합니다.' +
    '<br><br>' +
    '회사는 제1항에 따라 회원가입을 신청한 이용자에게 다음 각 호의 사유가 인정되는 경우 그 사유가 해소될 때까지 회원등록을 거부할 수 있습니다.' +
    '<br>' +
    '• 가입을 신청한 이용자가 본 약관 제7조 제3항에 의하여 이전에 회원자격을 상실한 적이 있는 경우' +
    '<br>' +
    '• 등록 내용에 허위, 기재누락, 오기가 있는 경우' +
    '<br>' +
    '• 본 약관 제7조 제3항 각 호에 해당하는 사유가 있거나, 그와 같은 사유가 있을 것으로 볼 상당한 우려가 있는 경우' +
    '<br>' +
    '• 기타 회원으로 등록하는 것이 회사의 관리적, 기술적 측면에서 현저히 지장이 있다고 판단되는 경우' +
    '<br><br>' +
    '만 14세 미만의 아동은 회원가입이 제한됩니다.' +
    '<br><br>' +
    '회원가입은 회사의 승낙이 가입을 신청한 이용자에게 도달한 때에 완료됩니다.' +
    '<br><br><br>' +
    '제7조(회원의 탈퇴 및 회원자격의 정지·상실)' +
    '<br><br>' +
    '회원은 회사에 언제든지 탈퇴를 요청할 수 있으며, 회원이 탈퇴 요청을 하는 경우에는 회사는 즉시 회원탈퇴에 필요한 조치를 취하여야 합니다. 단, 다음과 같은 사유가 있는 경우 회사는 해당 사유가 해소될 때까지 해당 회원의 탈퇴를 제한할 수 있습니다.' +
    '<br>' +
    '1. 결제대기, 주문접수 상태의 주문이 존재할 경우' +
    '<br>' +
    '2. 교환, 반품, 재배송, 보상, 환불 등 진행중인 결제 건이 존재하는 경우' +
    '<br><br>' +
    '회원은 탈퇴를 요청하기 전에 모든 거래를 완결시키기 위해서 필요한 조치를 취하여야 하며, 이를 따르지 않고 회원을 탈퇴할 경우 불이익이 있을 수 있습니다. 회사는 온라인스토어 서비스 이용과 관련한 채권·채무관계가 남아 있는 경우에 채권추심, 채무변제 등의 목적으로 개인정보를 이용할 수 있고, 법령상 특별한 규정이 있는 경우에는 개인정보를 법령이 정한 목적 및 기간의 범위 내에서 보관할 수 있습니다.' +
    '<br><br>' +
    '회원이 다음 각 호의 사유에 해당하는 경우, 회사는 회원에 대하여 해당 사유를 고지하고 회원의 자격을 정지하거나 상실 시킬 수 있으며 회원 자격이 정지 또는 상실될 경우 회원으로의 혜택은 전부 소멸됩니다.' +
    '<br>' +
    '• 사이트를 이용하여 구입한 상품의 대금, 기타 회사 이용과 관련하여 회원이 부담하는 채무를 기일에 이행하지 않는 경우' +
    '<br>' +
    '• 사이트의 이용과 관련하여 법령 또는 본 약관이 금지하거나 공서양속에 반하는 행위를 하는 경우' +
    '<br>' +
    '• 기타 회사의 합리적인 판단에 따라 해당 회원에 대하여 사이트 서비스 제공을 거부할 필요가 있다고 인정되는 경우' +
    '<br>' +
    '• 회원정보에 허위 내용을 입력하거나 타인의 정보를 도용한 경우' +
    '<br>' +
    '• 회원정보를 잘못 입력하거나 정확한 정보로 변경하지 않는 등 회원의 귀책사유로 인하여 회사가 상당한 노력을 기울였음에도 불구하고 회원에게 통지 또는 연락을 할 수 없게 된 경우' +
    '<br>' +
    '• 사이트 운영과 관련하여 불가피한 관리적, 기술적 필요 내지 사유가 있어서 사이트 이용에 현저한 지장이 있는 경우' +
    '<br>' +
    '• 본 항에 따라 회원의 자격이 정지 또는 상실되었으나 부정한 수단으로 다시 회원 등록을 한 경우' +
    '<br><br>' +
    '회사는 제3항에 따라 회원 자격을 정지 또는 상실 시킬 경우 회원에게 회원자격이 정지 또는 상실된다는 사실과 그 사유를 통지하고 30일 간의 소명 기회를 부여할 수 있습니다.' +
    '<br><br>' +
    '회사는 회원의 제4항에 의한 소명에 정당한 이유가 있다고 인정할 경우, 해당 회원에 대한 회원자격의 정지 또는 상실을 철회할 수 있습니다.' +
    '<br><br>' +
    '회사는 제1항에 따라 회원이 탈퇴하거나 제3항에 따라 회원의 자격을 상실 시키는 경우, 해당 회원의 등록을 말소하고 개인정보를 파기합니다. 단, 법령상 특별한 규정이 있는 경우에는 회사는 해당 회원의 개인정보를 법령이 정한 목적 및 기간의 범위 내에서 계속 보관할 수 있습니다.' +
    '<br><br>' +
    '회사는 회원의 개인정보 보호를 위해서 온라인스토어에 마지막으로 로그인한 후 1년간 로그인 기록이 없는 회원에 대하여 이용계약을 해지하고 회원의 개인정보를 파기하는 등 회원탈퇴에 필요한 조치를 취합니다. 이 경우 이용계약 해지 30일 전까지 이용계약 해지 및 개인정보 파기에 대해서 본 약관 제23조에서 정한 방법에 따라 고지합니다.' +
    '<br><br><br>' +
    '제8조(서비스 이용)' +
    '<br><br>' +
    '회원은 본 약관 및 서비스 화면에서 회사가 제공하는 모든 공지사항을 준수해야 합니다. 회원은 본 약관 및 제공된 공지사항을 위반하거나 준수하지 않아 발생하는 모든 손해에 대해 전적으로 책임을 집니다.' +
    '<br><br>' +
    '회사와 분쟁이 발생한 경우 회원은 분쟁해결을 위하여 성실한 노력을 하여야 합니다. 회원의 분쟁해결에 대한 신의가 없어 회사 또는 제3자에게 손해가 발생한 경우에는 그 손해에 대한 모든 책임을 회원이 부담합니다.' +
    '<br><br>' +
    '회사는 회원이 거래에 사용된 결제수단을 사용할 수 있는 적절한 권한이 있는지 확인할 수 있으며, 확인이 완료될 때까지 거래를 중단할 수 있습니다. 회사는 회원에게 서비스를 안전하게 제공할 수 있도록 각종 시설 및 데이터를 관리하고, 서비스가 본인의 의도한 목적에 맞게 이용되고 있는지 확인합니다. 회원이 서비스의 의도한 목적을 위반한 것으로 확인될 경우, 회사는 회원에게 설명을 요구하고 구매 취소(선주문 포함) 등 필요한 조치를 취할 수 있습니다. 미성년자가 법적 보호자의 동의 없이 사이트를 통해 상품 또는 서비스를 구매하는 경우 미성년자 또는 법적 보호자는 계약을 취소할 수 있습니다.' +
    '<br><br><br>' +
    '제9조(회사의 의무)' +
    '<br><br>' +
    '회사는 본 약관에 따라 서비스를 지속적이고 안정적으로 제공하기 위해 최선의 노력을 기울여야 하며, 본 약관, 관련법 또는 공서양속에서 금지하는 행위를 하여서는 아니 됩니다.' +
    '<br><br>' +
    '회사는 본 약관에서 요구하는 경우를 제외하고는 회원의 동의 없이 회사에 알려진 회원의 정보를 제3자에게 제공할 수 없습니다.' +
    '<br><br>' +
    '회사는 회원의 개인정보(신용정보 포함)를 보호하고 안전한 서비스 이용을 위해 보안시스템을 구축 및 유지합니다. 회사는 개인정보 보호방침을 공개하고 준수해야 합니다. 회사는 회원의 동의 없이 영리목적의 상업용 전자메일, 앱 푸시 알림, 그 밖의 홍보물을 발송할 수 없습니다.' +
    '<br><br>' +
    '회사는 회원의 의견 또는 불만사항이 객관적으로 타당하다고 인정되는 경우 불만사항 해결 및 신속한 대응을 위하여 노력하여야 하며, 신속한 처리가 어려운 경우 서비스 화면에 사유 및 처리 일정을 게시하거나 이메일, 기타 전자적 방법으로 회원에게 통지하여야 합니다.' +
    '<br><br>' +
    '회사가 회원에 대한 통지를 하는 경우, 회사와 회원 간의 별도의 약정이 없는 한, 회원이 온라인스토어를 가입 및 이용하면서 등록한 이메일, 전화, SMS, 앱푸쉬(APP Push) 메시지 등의 방법으로 전송합니다.' +
    '<br><br>' +
    '회사는 불특정다수 회원에 대한 통지의 경우 1주일 이상 온라인스토어의 화면에 게시함으로써 개별 통지에 갈음할 수 있습니다. 다만, 회사는 통지의 대상이 되는 사안이 온라인스토어와 관련된 회원 본인의 거래 등 회원의 관리관계에 중대한 영향을 미치는 사항인 경우에는 해당 회원에 대하여 제6항에 따라 개별적으로 통지합니다.' +
    '<br><br><br>' +
    '제10조(회원의 의무)' +
    '<br><br>' +
    '회원은 회사의 약관, 규정, 서비스 정책, 이용 가이드라인 및 관련 법규를 준수해야 하며, 회사의 운영에 지장을 주는 행위를 하여서는 아니 됩니다.' +
    '<br><br>' +
    '회원은 다음 각 호의 행위를 하여서는 아니 됩니다:' +
    '<br>' +
    '• 회사가 제공하는 서비스를 이용하지 않고 회원 간의 직거래("직거래"라 함)를 하거나 타인을 유도하는 행위.' +
    '<br>' +
    '• 회사 또는 다른 회원의 활동을 방해하거나 사이트 이용을 통해 부당이득을 취하는 등 통상의 거래관행에 부합하지 않는 부정행위를 하거나 거래행위를 하는 행위.' +
    '<br>' +
    '• 여신전문금융업법, 정보통신망 이용촉진 및 정보보호 등에 관한 법률, 그 밖의 관련 법령을 위반하여 비정상적인 지급행위를 한 경우.' +
    '<br>' +
    '• 회사가 제공하는 소정의 서비스 이용방법에 반하여 비정상적인 방법으로 서비스를 이용하거나 회사의 정보처리시스템에 무단으로 접속하는 행위.' +
    '<br>' +
    '• 회사 또는 제3자의 권리를 침해하거나 침해할 우려가 있는 행위를 하거나 상거래 질서를 위협하는 행위.' +
    '<br>' +
    '• 신청 또는 변경 시 허위 내용의 등록' +
    '<br>' +
    '• 타인의 정보 도용' +
    '<br>' +
    '• 사이트에 게시된 정보의 무단 변경' +
    '<br>' +
    '• 회사가 정한 정보 이외의 정보(컴퓨터 프로그램 등)의 송신 또는 게시' +
    '<br>' +
    '• 회사 또는 제3자의 저작권 등 지식재산권에 대한 침해' +
    '<br>' +
    '• 회사 또는 제3자의 명예를 손상시키거나 업무를 방해하는 행위' +
    '<br>' +
    '• 외설 또는 폭력적인 메시지·화상·음성, 허위 영상물, 아동·청소년 대상 성착취물 기타 공서양속에 반하는 정보를 몰에 공개 또는 게시하는 행위' +
    '<br>' +
    '• 회사가 제공하는 서비스의 정상적인 운영을 방해하는 비정상적 결제·어뷰징 행위' +
    '<br><br>' +
    '회원이 제2항의 규정을 위반한 경우 회사는 이용약관의 해지, 물품몰수, 회원자격 제한, 카드결제 취소 또는 정지, 그 밖의 민형사상 법률행위 등의 조치를 취할 수 있습니다.' +
    '<br><br><br>' +
    '제11조(상품)' +
    '<br><br>' +
    '상품은 앱에서 사용되는 온라인 상품으로 유통기한 및 제한사항에 대한 세부사항이 서비스 화면에 표시됩니다. 상품의 가격은 환율 또는 회사의 서비스 정책에 따라 변경될 수 있습니다. 구매 후 7일이 경과된 물품은 취소 및 환불이 불가하며, 유효기간 만료 또는 회원자격 상실 시 소멸됩니다.' +
    '<br><br>' +
    '회사가 별도로 명시하지 않는 한 타인에게 물품을 양도할 수 없으며, 불법적인 용도 또는 무단 사용으로 사용할 수 없습니다. 위반 시 회사는 물품을 무효화하고 회원의 자격을 제한하거나 해지할 수 있습니다.' +
    '<br><br>' +
    '회원이 부정한 방법으로 물품을 취득한 것이 확인되는 경우 회사는 물품을 취소하고 회원자격 상실 및 민형사상 소송을 포함한 법적 조치를 취할 수 있습니다.' +
    '<br><br><br>' +
    '제12조(구매신청)' +
    '<br><br>' +
    '회원은 본 약관과 유사하거나 본 약관에 규정된 방법으로 구매를 신청할 수 있습니다. 회사는 사용자가 구매를 신청하는 경우 다음 각 호의 정보를 알기 쉽게 제공해야 합니다:' +
    '<br>' +
    '• 제품 또는 품목 검색 및 선택' +
    '<br>' +
    '• 수취인 이름, 주소, 전화번호, 이메일 주소(또는 휴대폰 번호) 입력(해외 배송지의 경우 영문으로 기재한다)' +
    '<br>' +
    '• 상품 설명, 서비스 제한, 배송비 또는 설치비 등 비용 확인' +
    '<br>' +
    '• 물품 또는 물품에 대한 구매신청 확인 및 회사의 확인에 대한 동의' +
    '<br>' +
    '• 약관 내용, 청약철회권이 제한되는 서비스, 배송료 등 비용부담과 관련한 내용에 대한 확인' +
    '<br>' +
    '• 이 약관에 동의하고 위 제e.호의 사항을 확인하거나 거부하는 표시' +
    '<br>' +
    '• 결제방법의 선택' +
    '<br><br>' +
    '회사는 다음의 경우 구매신청을 거절할 수 있습니다:' +
    '<br>' +
    '• 신청서에 허위, 누락, 잘못된 정보가 있는 경우.' +
    '<br>' +
    '• 미성년자가 담배나 술 등 청소년보호법에서 금지하는 재화나 용역을 구입한 경우.' +
    '<br>' +
    '• 구매 신청을 수락하는 것이 회사의 기술적 능력을 현저히 저해하는 경우.' +
    '<br><br>' +
    '회사가 제3자에게 구매자 개인정보를 제공하거나 취급을 위탁할 필요가 있는 경우 관계 법령에 따라 구매자에게 알리고 필요한 동의를 받는다.' +
    '<br><br><br>' +
    '제13조(계약의 성립)' +
    '<br><br>' +
    '회사는 제12조와 같은 구매신청에 대하여 다음 각 호에 해당하면 승낙하지 아니할 수 있다.' +
    '<br>' +
    '• 신청 내용에 허위, 기재누락, 오기가 있는 경우' +
    '<br>' +
    '• 미성년자가 관련 법령에서 금지하는 상품등을 구매하는 경우' +
    '<br>' +
    '• 기타 구매신청에 승낙하는 것이 회사 기술상 현저히 지장이 있다고 판단하는 경우' +
    '<br><br>' +
    '회사의 승낙이 수신확인통지 형태로 이용자에게 도달한 시점에 계약이 성립한 것으로 본다.' +
    '<br><br><br>' +
    '제14조(지급방법)' +
    '<br><br>' +
    '회사는 이용자가 구매한 상품에 대한 대금지급방법을 다음 각 호의 방법 중 어느 하나로 제공할 수 있습니다. 단, 대금지급방법은 회사의 내부 정책 및 관리적, 기술적 사유에 따라서 변경될 수 있습니다.' +
    '<br>' +
    '1. 폰뱅킹, 인터넷뱅킹 등의 각종 계좌이체' +
    '<br>' +
    '2. 선불카드, 직불카드, 신용카드 등의 각종 카드 결제' +
    '<br>' +
    '3. 전자화폐에 의한 결제' +
    '<br>' +
    '4. 회사와 계약을 맺었거나 회사가 인정한 상품권에 의한 결제' +
    '<br>' +
    '5. 기타 전자적 지급 방법에 의한 대금 지급 등' +
    '<br><br>' +
    '회사는 이용자의 구매금액에 대하여 내부정책 및 외부 결제업체(은행사, 카드사 등), 기타 관련 법령의 변경에 따라 월 누적 결제액, 결제한도 등의 거래한도를 정할 수 있으며, 해당 이용자는 그 한도를 초과하는 범위에서 상품을 구매하고자 할 경우 거래한도의 초과로 인하여 상품구매가 불가능할 수 있습니다.' +
    '<br><br><br>' +
    '제15조(수신확인통지 및 구매신청 변경 및 취소)' +
    '<br><br>' +
    '회사는 본 약관 제12조에 따른 이용자의 구매신청이 있는 경우 이용자에게 수신확인통지를 합니다.' +
    '<br><br>' +
    '수신확인 통지를 받은 이용자는 의사표시의 불일치 등이 있는 경우에는 수신확인통지를 받은 후 즉시 구매신청의 변경 및 취소를 요청할 수 있고, 회사는 구매신청 상품의 준비 및 배송 전에 이용자의 요청이 있는 경우에는 지체없이 그 요청에 따라 처리하여야 합니다. 다만, 구매신청 상품에 대하여 출고지시 등 상품의 준비가 이루어진 경우 또는 배송이 이루어진 경우에는 이용자의 요청에 따른 처리가 어려울 수 있고, 이 경우 본 약관 제17조의 청약철회 등에 관한 규정에 따릅니다.' +
    '<br><br>' +
    '구매 취소에 대한 환불은 21조에 따른 절차가 완료되는 대로 이루어질 예정입니다.' +
    '<br><br>' +
    '결제 중 할인쿠폰을 사용한 경우 쿠폰 사용이 취소됩니다. 단, 쿠폰이 만료된 경우 환불 즉시 무효 처리됩니다.' +
    '<br><br>' +
    '패키지로 구매한 상품의 일부를 사용할 경우 부분 환불은 불가능하며, 미사용 상태에서 7일 이내에 구매 취소의사를 밝히면, 본인인증 확인 후 환불 수수료(환불금액의 10%)를 제외한 금액만큼 환불 처리 가능합니다.' +
    '<br><br><br>' +
    '제16조(인도 및 거래의 완료)' +
    '<br><br>' +
    '회원은 구매한 상품 또는 물품의 인도완료일로부터 일정기간(7일) 이내에 구매, 교환, 반품 등의 의사표시를 하여야 합니다.' +
    '<br><br>' +
    '제1항에서 정한 지정기간 내에 회원이 구매·교환·반품에 대한 의사표시를 하지 않을 경우, 회사는 회원이 자동으로 구매를 확인할 의사를 표시한 것으로 간주하여 거래에 대한 자동 구매 확인을 진행할 수 있습니다.' +
    '<br><br><br>' +
    '제17조(철회 등의 권리)' +
    '<br><br>' +
    '회사와 재화 또는 상품의 구매에 관한 계약을 체결한 회원은 재화 또는 상품을 공급받은 날로부터 7일 이내에 전자상거래법 등 관련법에 따라 반환 또는 교환을 신청할 수 있습니다. 다만, 전자상거래법에 청약철회에 관한 구체적인 규정이 있는 경우에는 그 규정을 적용합니다.' +
    '<br><br>' +
    '회원은 제1항에도 불구하고 다음 각 호의 경우에는 반환 및 교환을 요구할 수 없습니다:' +
    '<br>' +
    '• 회원의 책임으로 인하여 물품 또는 제품이 분실 또는 파손된 경우(물품 또는 제품의 내용물을 확인하기 위하여 포장이 파손된 경우는 제외합니다).' +
    '<br>' +
    '• 회원의 사용 또는 부분소비로 인하여 상품 또는 상품의 가치가 현저하게 하락한 경우.' +
    '<br>' +
    '• 시간의 경과로 재판매가 곤란할 정도로 재화나 상품의 가치가 현저하게 감소한 경우.' +
    '<br>' +
    '• 복제 가능한 제품 또는 제품의 포장이 손상된 경우.' +
    '<br>' +
    '• 문화산업진흥기본법 제2조 제5호의 서비스 또는 디지털콘텐츠의 제공이 개시된 경우.' +
    '<br>' +
    '• 주문에 따라 개별적으로 생산되는 물품 또는 상품에 대하여 청약철회 등이 발생한 경우에 제조자가 회수할 수 없는 중대한 손실이 있는 경우와 이 사실을 사용자에게 별도로 통지하고 거래에 관한 사용자의 서면동의를 미리 받은 경우.' +
    '<br>' +
    '• 관련 법령에 따른 기타 반환 제한 사유가 있는 경우.' +
    '<br><br>' +
    '제1항 및 제2항에도 불구하고 상품 또는 상품의 내용이 표시·광고된 내용과 다르거나 약정대로 계약이 이행되지 않을 경우 회원은 상품 또는 상품을 수령한 날부터 3개월 이내 또는 회원이 그 사실을 알게 된 날부터 30일 이내에 반환 또는 교환을 신청할 수 있습니다.' +
    '<br><br>' +
    '회원이 제1항 또는 제3항에 따라 교환을 신청하였으나 회사에 교환요청 물품의 재고가 없는 경우 회원은 물품 또는 상품에 대한 교환을 받을 수 없습니다. 이 경우 제조자는 사용자의 의사를 확인한 후 교환요청을 반환으로 처리할 수 있습니다.' +
    '<br><br>' +
    '반품 또는 교환에 필요한 배송비 및 기타 비용은 당사자가 부담합니다. 단, 물품 또는 제품의 하자 또는 오배송으로 인한 반품 또는 교환의 경우에는 회사가 비용을 부담합니다. 회원의 단순 변심으로 인한 반품 또는 교환의 경우에는 회원이 비용을 부담합니다.' +
    '<br><br>' +
    '회원의 반품 및 교환 요청을 회사가 거부할 경우 해당 주문은 자동으로 구매 확인서로 전환됩니다.' +
    '<br><br><br>' +
    '제18조(사용제한조치)' +
    '<br><br>' +
    '회사가 제공하는 사이트 등을 이용하는 회원들의 쾌적하고 안전한 경험을 보장하기 위해 신고 활동을 통해 약관 및 정책을 위반하는 회원의 이용을 제한하는 조치를 시행하게 되었습니다.' +
    '<br><br>' +
    '다음 활동으로 인해 사용 제한 조치가 발생할 수 있습니다:' +
    '<br>' +
    '• 명시적인 내용의 전송 또는 게시, 불법 도박 사이트 홍보' +
    '<br>' +
    '• 불법 녹음물, 허위 영상물 또는 아동 착취물 공유' +
    '<br>' +
    '• 타인의 개인정보 및 권리를 공개하거나 침해하는 행위' +
    '<br>' +
    '• 타인 계정 탈취' +
    '<br>' +
    '• 타인에 대한 명예훼손, 폭언, 확인할 수 없는 정보 공유 등의 행위' +
    '<br>' +
    '• 기타 예외적인 상황' +
    '<br><br>' +
    '이용 제한 조치가 적용될 경우 특정 기능 또는 회사의 전체 서비스에 대한 액세스가 제한될 수 있습니다.' +
    '<br><br>' +
    '회원이 사용제한 조치를 받으면 고객지원센터에 연락하여 조치 이유와 불편사항 해결 방법에 대한 정보를 얻으십시오.' +
    '<br><br>' +
    '쿠폰 및 포인트는 본인만 사용할 수 있으며, 제3자를 대신하여 사용하거나 금전적 대가로 타인에게 제공하는 것을 금지합니다. 이를 위반할 경우, 회사는 해당 포인트나 쿠폰을 몰수하거나 계정을 정지할 수 있으며, 서비스 이용에 제한을 둘 수 있습니다.' +
    '<br><br><br>' +
    '제19조(권리 등의 소유)' +
    '<br><br>' +
    '회사가 제공하는 서비스와 관련된 권리(데이터, 소프트웨어 및 게시물에 대한 저작권 포함)는 회사에 귀속됩니다.' +
    '<br><br>' +
    '회원은 회사가 소유한 저작권 기타 지식재산권을 회사의 사전 승낙 없이 복제, 송신, 출판, 배포, 방송 기타의 방법으로 이용하거나 제3자에게 이용하도록 하는 등의 침해행위를 하여서는 안 됩니다.' +
    '<br><br>' +
    '회원은 사이트를 이용함으로써 얻은 정보를 회사의 사전 승낙 없이 복제, 송신, 출판, 배포, 방송 기타 방법에 의하여 영리목적으로 이용하거나 제3자에게 이용하게 하여서는 안 됩니다.' +
    '<br><br>' +
    '회원이 고객상품평 등을 통하여 직접 등록한 게시물의 저작권은 이를 작성한 회원 본인에게 있으며, 해당 게시물의 저작권 침해를 비롯한 일체의 민·형사상 책임은 회원이 부담합니다. 단 회사의 고의 또는 중과실이 있으면 회사가 해당 책임을 부담합니다.' +
    '<br><br>' +
    '회사는 제3항에 따라 회원이 등록한 게시물을 검색 또는 다른 사이트에 노출하거나, 판촉, 홍보 및 기타의 자료로 무상 사용할 수 있습니다. 다만, 해당 게시물을 등록한 회원이 게시물의 삭제와 함께 사용중지를 요청한 경우에는 즉시 사용을 중지합니다.' +
    '<br><br>' +
    '회사는 회원이 등록한 고객상품평 등 게시물이 다음 각 호에 해당하는 경우, 해당 이용자에 대한 사전통보 없이 게시물을 숨김 또는 삭제할 수 있습니다.' +
    '<br>' +
    '• 법령을 위반하거나 공공질서 및 미풍양속에 위배되는 내용을 포함하는 경우' +
    '<br>' +
    '• 허위 또는 과대광고의 내용을 포함하는 경우' +
    '<br>' +
    '• 정치, 사회, 경제적 분쟁을 야기할 수 있는 내용을 포함하는 경우' +
    '<br>' +
    '• 해당 상품에 대한 평가와 무관한 내용을 담고 있는 경우' +
    '<br>' +
    '• 직거래 유도 또는 타 사이트의 링크를 게시 및 홍보하는 경우' +
    '<br>' +
    '• 회사를 포함한 제3자의 권리나 개인정보, 명예, 신용 기타 정당한 권리 또는 이익을 침해하는 경우' +
    '<br>' +
    '• 특정 단어나 문구를 반복 삽입하거나 의미 없는 특수기호 내지 부호, 외국어로 작성된 경우' +
    '<br>' +
    '• 회사가 제공하는 방법에 의하지 아니하고 비정상적인 방법으로 작성 및 게시하는 경우' +
    '<br>' +
    '• 상품이 품절되거나 기술적 사양의 변경 등으로 특정 상품의 판매가 중단되어 더 이상 제공할 수 없는 경우' +
    '<br>' +
    '• 회사가 사이트 운영과 관련하여 관리적, 기술적 필요 내지 사유가 있다고 합리적으로 판단하는 경우' +
    '<br>' +
    '• 회사가 제공하는 사이트 서비스의 원활한 제공을 방해하는 경우' +
    '<br><br>' +
    '회사는 회원이 작성한 고객상품평, 고객 설문조사, 회사에 제출한 의견 등의 컨텐츠를 무상으로 서비스 개선, 홍보, 제품개발, 통계작성 등의 목적으로 이용, 공개, 게시, 복제, 전송 등 할 수 있으며 번역, 개작 등의 2차 저작물 작성이 가능합니다. 단, 회원이 회사의 본 조에 따른 사용을 원하지 않는 경우 고객센터를 통하여 자신의 정당한 권리를 보호받을 수 있습니다.' +
    '<br><br><br>' +
    '제20조(회사의 면책조항)' +
    '<br><br>' +
    '회사는 다음 사항에 대해 책임을 지지 않습니다:' +
    '<br>' +
    '• 사용자가 앱에 게시한 정보, 자료 및 사실에 대한 진실성, 정확성, 신뢰성 및 활용성뿐만 아니라 이러한 게시된 자료의 사용으로 인해 발생하는 모든 결과.' +
    '<br>' +
    '• 서비스를 매개로 하여 발생한 회원 간 또는 회원과 제3자 간의 분쟁.' +
    '<br>' +
    '• 사용자가 임의로 금지된 수정사항을 변경하거나 변경된 내용을 고지하지 않은 경우 앱에 참여한 회원과 관련하여 발생할 수 있는 법적 분쟁, 책임 및 불이익.' +
    '<br>' +
    '• 사용자가 앱에 기재한 원본 내용과 회사에 제공하는 요청된 서비스 내용 간의 불일치로 인해 발생하는 모든 결과, 불이익 및 법적 책임.' +
    '<br><br>' +
    '회사의 고의 또는 중대한 과실로 인한 것이 아닌 한 다음과 같은 상황에서 발생한 손해에 대해서는 책임을 지지 않습니다:' +
    '<br>' +
    '• 본 약관 제5조 제2항에 따라 수행되는 서비스 제한 또는 중지 또는 본 약관에서 위임한 하위 정책.' +
    '<br>' +
    '• 회원이 개인정보를 불완전하게 제공하거나 본 약관에 따라 필요한 정보를 업데이트하지 않아 발생한 손해.' +
    '<br>' +
    '• 회원이 서비스에 접속하거나 이용함에 있어 고의 또는 과실이 있는 행위로 인하여 회원 또는 제3자가 입은 손해.' +
    '<br>' +
    '• 천재지변, 전쟁, 민란, 그 밖의 불가항력적 사건으로 인하여 회원이 입은 손해.' +
    '<br>' +
    '• 회원이 사이트를 이용함으로써 기대되는 이익을 얻지 못하거나 사이트를 통해 얻은 정보 혹은 자료를 이용하여 발생한 손해.' +
    '<br><br><br>' +
    '제21조(광고게재)' +
    '<br><br>' +
    '회사는 이용자에게 최상의 서비스를 원활하게 제공하기 위한 재정기반을 마련하기 위하여 상업용 광고를 화면에 게재하거나 「정보통신망 이용촉진 및 정보보호 등에 관한 법률」 등에서 정한 요건에 따라 이메일, SMS, 앱푸쉬(APP Push) 메시지 등을 이용하여 개별 이용자에게 보낼 수 있습니다. 단, 수신거절의 의사를 명백히 표시한 이용자에 대해서는 더 이상 이메일, SMS, 앱푸쉬(APP Push) 메시지 등을 발송하지 않습니다.' +
    '<br><br>' +
    '회사는 본 사이트를 통한 광고주의 판촉활동에 회원이 직접 참여함으로써 발생하는 손해에 대하여는 일체의 책임을 부담하지 않습니다.' +
    '<br><br><br>' +
    '제22조(분쟁해결)' +
    '<br><br>' +
    '회사는 회원 간의 분쟁을 합리적이고 원활하게 해결하기 위해 고객센터를 운영하고 있습니다.' +
    '<br><br>' +
    '회원은 공정성의 원칙에 입각하여 성실하게 분쟁해결절차에 참여하여야 합니다.' +
    '<br><br><br>' +
    '제23조(관할법·관할)' +
    '<br><br>' +
    '서비스 계약의 준거법은 대한민국의 법률입니다.' +
    '<br><br>' +
    '서비스 계약과 관련하여 회사와 회원 간에 발생한 분쟁이나 소송은 민사소송법에 따라 관할 법원에서 해결합니다.' +
    '<br><br><br>' +
    '제24조(판매상품에 대한 책임여부)' +
    '<br><br>' +
    '주식회사 딜리버드로지스틱스에서 운영하는 앱/웹에서 판매하는 모든 상품은 주식회사 딜리버드로지스틱스에서 책임지고 있습니다.' +
    '<br>' +
    '* 민원 담당자 : 김종익 / 051-742-7777' +
    '<br><br>',
  en:
    '<h4>Terms and Conditions of Use</h4>' +
    '<div>' +
    '• These Terms and Conditions of Use are effective as of July 21, 2023.' +
    '<br>' +
    '• [October 21, 2024] Article 19 (Restrictions on Use) – Addition of clause restricting use of points' +
    '<br>' +
    '• [May 1, 2025] Change of service operator: Globewave Co., Ltd. → DeliveredLogistics Co., Ltd.' +
    '<br><br><br>' +
    'Article 1 (Purpose)' +
    '<br><br>' +
    'These Terms and Conditions govern the rights and obligations, and responsibilities between DeliveredLogistics Co., Ltd. (hereinafter "Company") and its member in connection with the use of the online marketplace intermediary service and online marketplace service provided by the Company.' +
    '<br><br><br>' +
    'Article 2 (Definitions)' +
    '<br><br>' +
    'The definitions of terms used in these Terms and Conditions are as follows, and terms not defined herein shall be interpreted in accordance with applicable laws and separate guidelines provided within the service application:' +
    '<br><br>' +
    'a. "Service" means the online marketplace intermediary service, online marketplace service, community participation, fan voting, and other services provided by the Company, through which members who have agreed to the membership terms may access the electronic system and conduct online transactions.' +
    '<br><br>' +
    'b. "Site" means the online store operated by the Company (https://www.giftifan.com), which provides goods, services, or other offerings to members using computer and information communications facilities. This includes websites, mobile web, and applications operated by the Company.' +
    '<br><br>' +
    'c. "User" means a user who downloads the Company\'s application, agrees to these Terms and Conditions, concludes a service agreement, and properly registers for the service.' +
    '<br><br>' +
    'd. "Item Store" means a space where members can purchase goods. It is an online shopping mall operated by the Company.' +
    '<br><br>' +
    'e. "Goods" means online products used within the app, and detailed information on expiration dates and restrictions is displayed on the service screen.' +
    '<br><br>' +
    'f. "User Information" means information necessary to maintain service quality (nickname, email).' +
    '<br><br>' +
    'g. "Points" means a means of payment that may be used to purchase goods, etc. on the Site, divided into "Paid Points," which a member purchases for consideration, and "Free Points," which the Company grants without charge through events, promotions, and the like.' +
    '<br><br><br>' +
    'Article 3 (Effectiveness of Terms and Conditions)' +
    '<br><br>' +
    'The Company may establish separate policies, including individual policies (hereinafter "Policy"), to supplement and operate matters not stipulated in these Terms and Conditions. The Company will post such policies on the website. The policies, together with these Terms and Conditions, form part of the Terms of Service (hereinafter "Terms of Service"). A Member\'s agreement to these Terms and Conditions and policies shall have the same effect as signing the Terms of Service.' +
    '<br><br>' +
    'The Company may separately enact terms and conditions for specific services (hereinafter "Individual Terms"). If a member agrees to the Individual Terms, they shall form part of the Terms of Service. In case of conflict between the Individual Terms and these Terms and Conditions, the Individual Terms shall prevail.' +
    '<br><br><br>' +
    'Article 4 (Announcement and Revision of Terms and Conditions)' +
    '<br><br>' +
    "The Company shall post the contents of these Terms and Conditions as well as its trade name, representative's name, business address, telephone number, email address, and business registration number on the initial service screen of the website so that members may easily access them. The Company shall enable members to easily access and review these Terms and Conditions through a linked screen on the homepage." +
    '<br><br>' +
    'The Company may amend these Terms and Conditions and the Policies within the scope that does not violate the relevant laws and regulations. In such case, the Company shall announce the amended content and the effective date through the homepage from seven (7) days before the effective date until the day before. However, where the proposed changes are unfavorable to members, the amended Terms and Conditions and Policies shall be announced from thirty (30) days before the effective date until the effective date.' +
    '<br><br>' +
    'Where it is difficult to give notice as provided in the main text due to urgent and unavoidable circumstances, such as an amendment of these Terms and Conditions or the Policies caused by a change in the relevant statutes, the Company shall publish the amended Terms and Conditions or Policies before the effective date by the same method as the main text of Paragraph 1.' +
    '<br><br>' +
    "Where a member does not agree to the amended Terms and Conditions or Policies, the member may express refusal by the day before the effective date and terminate the use agreement. In such case, the member's rights, including unused Paid Points, shall be settled and refunded in accordance with Articles 15 and 17." +
    '<br><br>' +
    'Where the Company publishes or notifies the amended Terms and Conditions or Policies in accordance with this Article and a member does not express an intention before the effective date, the member shall be deemed to have agreed to the amended Terms and Conditions or Policies.' +
    '<br><br>' +
    'The amended Terms and Conditions shall not apply retroactively to a date before their effective date, except where they are favorable to the member.' +
    '<br><br>' +
    'Matters not provided for in these Terms and Conditions, and the interpretation thereof, shall be governed by the Act on the Consumer Protection in Electronic Commerce, Etc., the Act on the Regulation of Terms and Conditions, the Guidelines on Consumer Protection in Electronic Commerce, Etc. established by the Fair Trade Commission, and other relevant statutes or commercial practice.' +
    '<br><br><br>' +
    'Article 5 (Provision and Suspension of Services)' +
    '<br><br>' +
    'The types of services provided by the Company under these Terms and Conditions are as follows:' +
    '<br>' +
    '• Online commerce services and other related services.' +
    '<br>' +
    '• Online commerce intermediary services and other related services.' +
    '<br>' +
    '• Additional services necessary for or related to the provision of the above services.' +
    '<br><br>' +
    'Services are generally provided 24 hours a day, 365 days a year. However, the Company may suspend the provision of services temporarily or permanently in the event of maintenance, inspection, replacement, or breakdown of computers and other information-communication facilities, interruption of communications, operational or technical difficulties, technical improvements, or other substantial operational reasons, and will give notice of such changes through the website.' +
    '<br><br>' +
    'Notwithstanding paragraph 2, the Company may divide services into specific scopes and designate separate operating hours for each scope. Details will be announced through the homepage.' +
    '<br><br>' +
    'If the Company is unable to provide services due to changes in business, closure, merger, division, transfer, or other reasons, the Company shall comply with applicable laws. No separate compensation will be provided to members unless otherwise stipulated by applicable laws.' +
    '<br><br><br>' +
    'Article 6 (Membership Registration)' +
    '<br><br>' +
    'A user may register as a member free of charge, and applies for membership by entering member information in the registration form designated by the Company and indicating consent to these Terms and Conditions and to the collection, provision, and use of personal information.' +
    '<br><br>' +
    'Where any of the following grounds is found with respect to a user who has applied for membership under Paragraph 1, the Company may refuse member registration until the ground is resolved:' +
    '<br>' +
    '1. Where the applying user has previously lost member status under Article 7, Paragraph 3 of these Terms and Conditions;' +
    '<br>' +
    '2. Where the registration content contains false information, omissions, or errors;' +
    '<br>' +
    '3. Where any ground under the subparagraphs of Article 7, Paragraph 3 exists, or there is a reasonable concern that such a ground exists;' +
    '<br>' +
    '4. Where registering the user as a member is otherwise deemed to significantly impede the Company in administrative or technical respects.' +
    '<br><br>' +
    'Children under 14 years of age are restricted from membership registration.' +
    '<br><br>' +
    "Membership registration is completed when the Company's acceptance reaches the user who applied for registration." +
    '<br><br><br>' +
    'Article 7 (Member Withdrawal and Suspension or Loss of Member Status)' +
    '<br><br>' +
    "A member may request withdrawal from the Company at any time, and where a member makes a withdrawal request, the Company shall immediately take the measures necessary for withdrawal. However, the Company may restrict the member's withdrawal until the relevant ground is resolved in the following cases:" +
    '<br>' +
    '1. Where there is an order in a payment-pending or order-received state;' +
    '<br>' +
    '2. Where there is a payment in progress, such as exchange, return, re-delivery, compensation, or refund.' +
    '<br><br>' +
    'A member shall take the measures necessary to complete all transactions before requesting withdrawal; withdrawing without doing so may result in disadvantages. Where a credit-and-debt relationship related to the use of the online store remains, the Company may use personal information for purposes such as debt collection and repayment, and, where there are special provisions under statute, may retain personal information within the scope of the purpose and period prescribed by statute.' +
    '<br><br>' +
    "Where a member falls under any of the following, the Company may, after notifying the member of the relevant ground, suspend or revoke the member's status; where member status is suspended or revoked, all member benefits shall be extinguished:" +
    '<br>' +
    '• Where the member fails to perform, by the due date, the price of goods purchased through the Site or other debts borne in connection with use of the Company;' +
    '<br>' +
    '• Where the member commits an act prohibited by statute or these Terms and Conditions, or contrary to public order and morals, in connection with use of the Site;' +
    '<br>' +
    "• Where it is otherwise recognized, in the Company's reasonable judgment, that it is necessary to refuse provision of the Site service to the member;" +
    '<br>' +
    "• Where the member enters false information in the member information or misappropriates another person's information;" +
    '<br>' +
    "• Where, due to the member's fault such as entering incorrect member information or failing to update it with accurate information, the Company is unable to notify or contact the member despite considerable effort;" +
    '<br>' +
    '• Where there is significant impediment to use of the Site due to unavoidable administrative or technical needs or reasons in connection with operation of the Site;' +
    '<br>' +
    '• Where a member whose status has been suspended or revoked under this Article registers as a member again by fraudulent means.' +
    '<br><br>' +
    'Where the Company suspends or revokes member status under Paragraph 3, it may notify the member of the fact and grounds of the suspension or revocation and grant a 30-day opportunity to explain.' +
    '<br><br>' +
    "Where the Company recognizes that there is a justifiable reason in the member's explanation under Paragraph 5, it may withdraw the suspension or revocation of the member's status." +
    '<br><br>' +
    "Where a member withdraws under Paragraph 1, or the Company revokes member status under Paragraph 3, the Company shall delete the member's registration and destroy the personal information. However, where there are special provisions under statute, the Company may continue to retain the member's personal information within the scope of the purpose and period prescribed by statute." +
    '<br><br>' +
    "To protect members' personal information, the Company shall take measures necessary for withdrawal, such as terminating the use agreement and destroying personal information, with respect to a member who has had no login record for one (1) year after the last login to the online store. In such case, the Company shall give notice of the termination of the use agreement and the destruction of personal information, by the method provided in Article 23 of these Terms and Conditions, at least 30 days before the termination." +
    '<br><br><br>' +
    'Article 8 (Use of Services)' +
    '<br><br>' +
    'Members must comply with all notices provided by the Company in these Terms and Conditions and on the service screen. Members shall bear full responsibility for all damages arising from violations of, or non-compliance with, these Terms and Conditions and the notices provided.' +
    '<br><br>' +
    'In case of a dispute with the Company or other members, members must make sincere efforts to resolve the dispute. Members shall bear full responsibility for damages caused to the Company or third parties due to lack of good faith in dispute resolution.' +
    '<br><br>' +
    'The Company may verify whether members have appropriate authority to use the payment methods used in transactions and may suspend transactions until verification is complete. If a member is found to have violated the intended purpose of the service, the Company may request an explanation and take necessary measures including purchase cancellation. If a minor purchases goods or services without the consent of a legal guardian, the minor or legal guardian may cancel the contract.' +
    '<br><br><br>' +
    'Article 9 (Obligations of the Company)' +
    '<br><br>' +
    'The Company must make its best efforts to provide services continuously and stably, and shall not engage in acts prohibited by these Terms and Conditions, applicable laws, or public order and morals.' +
    '<br><br>' +
    "The Company shall not provide member information to third parties without the member's consent, except as required by these Terms and Conditions." +
    '<br><br>' +
    "The Company shall establish and maintain a security system to protect members' personal information and ensure safe service use. The Company shall disclose and comply with its privacy policy. The Company shall not send commercial emails, app push notifications, or other promotional materials without member consent." +
    '<br><br>' +
    'If member opinions or complaints are objectively recognized as valid, the Company must make efforts to resolve them promptly. If prompt processing is difficult, the Company shall notify members by posting on the service screen or by email or other electronic means.' +
    '<br><br>' +
    'Where the Company gives notice to a member, unless otherwise agreed between the Company and the member, it shall send the notice by the email, telephone, SMS, app push (APP Push) message, or similar method that the member registered when joining and using the online store.' +
    '<br><br>' +
    "For notice to an unspecified number of members, the Company may substitute individual notice by posting on the online store screen for at least one (1) week. However, where the matter subject to notice significantly affects the member's management relationship, such as the member's own transactions related to the online store, the Company shall notify the relevant member individually in accordance with Paragraph 5." +
    '<br><br><br>' +
    'Article 10 (Obligations of Members)' +
    '<br><br>' +
    "Members must comply with the Company's terms and conditions, regulations, service policies, usage guidelines, and applicable laws, and shall not engage in acts that interfere with the Company's operations." +
    '<br><br>' +
    'Members shall not engage in the following acts:' +
    '<br>' +
    '• Engaging in direct transactions between members or inducing others to do so without using services provided by the Company.' +
    '<br>' +
    '• Engaging in fraudulent acts or transactions inconsistent with normal business practices, such as interfering with the activities of the Company or other members or obtaining unjust profits.' +
    '<br>' +
    '• Making abnormal payment acts in violation of the Specialized Credit Finance Business Act, the Act on Promotion of Information and Communications Network Utilization and Information Protection, or other applicable laws.' +
    '<br>' +
    "• Using services in an abnormal manner contrary to methods provided by the Company, or accessing the Company's information processing systems without authorization." +
    '<br>' +
    '• Engaging in acts that infringe or are likely to infringe on the rights of the Company or third parties, or that threaten the order of commerce.' +
    '<br>' +
    '• Registering false content upon application or modification;' +
    '<br>' +
    "• Misappropriating another person's information;" +
    '<br>' +
    '• Unauthorized alteration of information posted on the Site;' +
    '<br>' +
    '• Transmitting or posting information (such as computer programs) other than that designated by the Company;' +
    '<br>' +
    '• Infringing the copyright or other intellectual property rights of the Company or a third party;' +
    '<br>' +
    '• Damaging the reputation of, or interfering with the business of, the Company or a third party;' +
    '<br>' +
    '• Disclosing or posting on the platform obscene or violent messages, images, or sounds, false video materials, child or youth sexual exploitation materials, or other information contrary to public order and morals;' +
    '<br>' +
    '• Engaging in abnormal payment or abusing acts that interfere with the normal operation of the services provided by the Company.' +
    '<br><br>' +
    'If a member violates paragraph 2, the Company may take measures such as termination, confiscation of goods, restriction of membership, cancellation or suspension of card payments, and other civil and criminal legal actions.' +
    '<br><br><br>' +
    'Article 11 (Goods)' +
    '<br><br>' +
    "Goods are online products used within the app, and detailed information on expiration dates and restrictions is displayed on the service screen. Prices may change according to exchange rates or the Company's service policies. Cancellation and refunds are not possible for goods purchased more than 7 days ago, and goods shall expire upon expiration of the validity period or loss of membership." +
    '<br><br>' +
    "Unless otherwise specified by the Company, goods cannot be transferred to others and cannot be used for illegal or unauthorized purposes. In case of violation, the Company may invalidate the goods and restrict or terminate the member's status." +
    '<br><br>' +
    'If a member is found to have obtained goods through fraudulent means, the Company may cancel the goods and take legal action including loss of membership and civil and criminal lawsuits.' +
    '<br><br><br>' +
    'Article 12 (Application for Purchase)' +
    '<br><br>' +
    'A member may apply for purchase by a method similar to, or prescribed in, these Terms and Conditions. Where a user applies for purchase, the Company shall provide the following information in an easily understandable manner:' +
    '<br>' +
    '• Search and selection of products or items;' +
    '<br>' +
    "• Entry of the recipient's name, address, telephone number, and email address (or mobile phone number) (for overseas delivery addresses, to be written in English);" +
    '<br>' +
    '• Confirmation of product descriptions, service restrictions, and costs such as delivery or installation fees;' +
    '<br>' +
    "• Confirmation of the application for purchase of the goods, and consent to the Company's confirmation;" +
    '<br>' +
    '• Confirmation of the contents of the Terms and Conditions, the services for which the right of withdrawal is restricted, and matters relating to cost burdens such as delivery fees;' +
    '<br>' +
    '• An indication agreeing to these Terms and Conditions and confirming or refusing the matters in item 5 above;' +
    '<br>' +
    '• Selection of the payment method.' +
    '<br><br>' +
    'The Company may refuse an application for purchase in the following cases:' +
    '<br>' +
    '• Where the application contains false, omitted, or incorrect information;' +
    '<br>' +
    '• Where a minor purchases goods or services prohibited by the Youth Protection Act, such as tobacco or alcohol;' +
    '<br>' +
    "• Where accepting the application would significantly impair the Company's technical capacity." +
    '<br><br>' +
    "Where the Company needs to provide a purchaser's personal information to a third party or to entrust the handling thereof, it shall notify the purchaser and obtain the necessary consent in accordance with the relevant statutes." +
    '<br><br><br>' +
    'Article 13 (Formation of Contract)' +
    '<br><br>' +
    'The Company may decline to accept an application for purchase under Article 12 in any of the following cases:' +
    '<br>' +
    '• Where the application contains false information, omissions, or errors;' +
    '<br>' +
    '• Where a minor purchases goods, etc. prohibited by the relevant statutes;' +
    '<br>' +
    '• Where it is otherwise determined that accepting the application would significantly impair the Company technically.' +
    '<br><br>' +
    "The contract is deemed formed at the time the Company's acceptance, in the form of a receipt-confirmation notice, reaches the user." +
    '<br><br><br>' +
    'Article 14 (Payment Methods)' +
    '<br><br>' +
    "The Company may provide any one of the following methods for payment of the price of goods purchased by a user. However, the payment method may change according to the Company's internal policy and administrative or technical reasons:" +
    '<br>' +
    '1. Various account transfers, such as phone banking and internet banking;' +
    '<br>' +
    '2. Various card payments, such as prepaid cards, debit cards, and credit cards;' +
    '<br>' +
    '3. Payment by electronic currency;' +
    '<br>' +
    '4. Payment by gift certificates contracted with, or recognized by, the Company;' +
    '<br>' +
    '5. Payment by other electronic payment methods.' +
    '<br><br>' +
    "The Company may set transaction limits, such as a monthly cumulative payment amount and a payment ceiling, with respect to a user's purchase amount in accordance with its internal policy, external payment providers (banks, card companies, etc.), and changes in other relevant statutes; where a user wishes to purchase goods beyond such a limit, the purchase may be impossible due to the excess over the transaction limit." +
    '<br><br><br>' +
    'Article 15 (Receipt-Confirmation Notice and Change or Cancellation of Purchase Application)' +
    '<br><br>' +
    "Where there is a user's application for purchase under Article 12 of these Terms and Conditions, the Company gives the user a receipt-confirmation notice." +
    '<br><br>' +
    "A user who has received a receipt-confirmation notice may, where there is a discrepancy in the declaration of intent, immediately request a change or cancellation of the purchase application after receiving the notice, and the Company shall, where there is a user request before preparation and delivery of the ordered goods, process it without delay in accordance with the request. However, where the goods have been prepared, such as by a shipping instruction, or where delivery has been made, processing according to the user's request may be difficult, in which case the provisions on withdrawal of subscription, etc. in Article 17 of these Terms and Conditions shall apply." +
    '<br><br>' +
    'A refund for a purchase cancellation shall be made as soon as the relevant settlement procedure is completed.' +
    '<br><br>' +
    'Where a discount coupon was used during payment, the use of the coupon is cancelled. However, where the coupon has expired, it is treated as void immediately upon refund.' +
    '<br><br>' +
    'Where part of goods purchased as a package is used, a partial refund is not possible; where the intention to cancel the purchase is expressed within seven (7) days while the goods are unused, a refund may be processed, after identity verification, in the amount remaining after deduction of a refund fee (10% of the refund amount).' +
    '<br><br><br>' +
    'Article 16 (Delivery and Completion of the Transaction)' +
    '<br><br>' +
    'A member shall express an intention as to purchase, exchange, or return, etc. within a certain period (7 days) from the date delivery of the purchased goods or items is completed.' +
    '<br><br>' +
    'Where a member does not express an intention as to purchase, exchange, or return within the period specified in Paragraph 1, the Company may deem that the member has expressed an intention to automatically confirm the purchase, and may proceed with automatic purchase confirmation for the transaction.' +
    '<br><br><br>' +
    'Article 17 (Right of Withdrawal)' +
    '<br><br>' +
    'A member who has concluded a contract for the purchase of goods or products with the Company may apply for return or exchange within seven (7) days from the date the goods or products are supplied, in accordance with the Electronic Commerce Act and other relevant laws. However, where the Electronic Commerce Act has specific provisions on withdrawal of subscription, those provisions apply.' +
    '<br><br>' +
    'Notwithstanding paragraph 1, members cannot request return or exchange in the following cases:' +
    '<br>' +
    '• If goods are lost or damaged due to reasons attributable to the member (excluding cases where packaging is damaged to check contents).' +
    '<br>' +
    "• If the value of goods has significantly decreased due to the member's use or partial consumption." +
    '<br>' +
    '• If the value of goods has significantly decreased over time to the extent that resale is difficult.' +
    '<br>' +
    '• If the packaging of reproducible products is damaged.' +
    '<br>' +
    '• If the provision of services or digital content under Article 2, Item 5 of the Framework Act on the Promotion of Cultural Industries has commenced.' +
    '<br>' +
    '• If there is significant loss that cannot be recovered by the manufacturer in the event of withdrawal of subscription for individually produced goods, and the user has been separately notified and prior written consent has been obtained.' +
    '<br>' +
    '• If there are other return restriction reasons under applicable laws.' +
    '<br><br>' +
    'Notwithstanding paragraphs 1 and 2, if the contents of goods differ from the displayed or advertised contents or the contract is not fulfilled as agreed, members may apply for return or exchange within 3 months from the date of receipt, or within 30 days from the date the member becomes aware of such fact.' +
    '<br><br>' +
    "If a member applies for exchange but the Company has no stock of the exchange-requested goods, the member cannot receive an exchange. In such cases, the manufacturer may process the exchange request as a return after confirming the user's intention." +
    '<br><br>' +
    "Shipping fees and other costs for returns or exchanges shall be borne by the relevant party. Costs for returns or exchanges due to defects or misdelivery shall be borne by the Company. Costs for returns or exchanges due to a member's simple change of mind shall be borne by the member." +
    '<br><br>' +
    "If the Company refuses a member's request for return or exchange, the relevant order shall automatically be converted to a purchase confirmation." +
    '<br><br><br>' +
    'Article 18 (Restrictions on Use)' +
    '<br><br>' +
    'To ensure a pleasant and safe experience for members using the Site, etc. provided by the Company, the Company has implemented measures to restrict the use of members who violate the Terms and Conditions and the Policies, through reporting activities.' +
    '<br><br>' +
    'The following activities may give rise to restriction-on-use measures:' +
    '<br>' +
    '• Transmitting or posting explicit content, or promoting illegal gambling sites;' +
    '<br>' +
    '• Sharing illegal recordings, false video materials, or child exploitation materials;' +
    '<br>' +
    "• Disclosing or infringing another person's personal information and rights;" +
    '<br>' +
    "• Hijacking another person's account;" +
    '<br>' +
    '• Defaming another person, using abusive language, or sharing unverifiable information about others;' +
    '<br>' +
    '• Other exceptional circumstances.' +
    '<br><br>' +
    "Where a restriction-on-use measure applies, access to specific functions or to the Company's entire service may be restricted." +
    '<br><br>' +
    'Where a member is subject to a restriction-on-use measure, the member should contact the customer support center to obtain information on the reason for the measure and on how to resolve the inconvenience.' +
    '<br><br>' +
    'Coupons and Points may be used only by the holder; using them on behalf of a third party, or providing them to others for monetary consideration, is prohibited. In the event of violation, the Company may confiscate the relevant Points or coupons, suspend the account, and restrict use of the service.' +
    '<br><br><br>' +
    'Article 19 (Ownership of Rights)' +
    '<br><br>' +
    '① The rights related to the services provided by the Company (including copyrights to data, software, and postings) belong to the Company.' +
    '<br><br>' +
    "② A member shall not infringe the copyrights or other intellectual property rights owned by the Company by reproducing, transmitting, publishing, distributing, broadcasting, or otherwise using them, or by allowing a third party to use them, without the Company's prior consent." +
    '<br><br>' +
    "③ A member shall not use, for profit-making purposes, the information obtained through use of the Site by reproducing, transmitting, publishing, distributing, broadcasting, or other means, nor allow a third party to do so, without the Company's prior consent." +
    '<br><br>' +
    '④ The copyright in a posting that a member directly registers, such as a customer product review, belongs to the member who created it, and the member bears all civil and criminal liability, including for any copyright infringement of such posting. However, where there is intent or gross negligence on the part of the Company, the Company bears such liability.' +
    '<br><br>' +
    '⑤ The Company may, under Paragraph 3, use a posting registered by a member free of charge by displaying it in search results or on other sites, or as material for promotion, publicity, and the like. However, where the member who registered the posting requests suspension of use together with deletion of the posting, the Company shall immediately suspend such use.' +
    '<br><br>' +
    '⑥ Where a posting registered by a member, such as a customer product review, falls under any of the following, the Company may hide or delete the posting without prior notice to the relevant user:' +
    '<br>' +
    '1. Where it contains content that violates statutes or is contrary to public order and good morals;' +
    '<br>' +
    '2. Where it contains false or exaggerated advertising content;' +
    '<br>' +
    '3. Where it contains content that may cause political, social, or economic disputes;' +
    '<br>' +
    '4. Where it contains content unrelated to the evaluation of the relevant product;' +
    '<br>' +
    '5. Where it induces direct dealing, or posts and promotes links to other sites;' +
    '<br>' +
    '6. Where it infringes the rights, personal information, reputation, credit, or other legitimate rights or interests of a third party, including the Company;' +
    '<br>' +
    '7. Where it repeatedly inserts particular words or phrases, or is written with meaningless special symbols or signs, or in a foreign language;' +
    '<br>' +
    '8. Where it is created and posted by abnormal means other than those provided by the Company;' +
    '<br>' +
    '9. Where a particular product can no longer be provided because its sale has been suspended due to being out of stock, a change in technical specifications, or the like;' +
    '<br>' +
    '10. Where the Company reasonably determines that there is an administrative or technical need or reason in connection with operation of the Site;' +
    '<br>' +
    '11. Where it interferes with the smooth provision of the Site service provided by the Company.' +
    '<br><br>' +
    'The Company may use, disclose, post, reproduce, transmit, etc., free of charge, content such as customer product reviews, customer surveys, and opinions submitted to the Company, for purposes such as service improvement, promotion, product development, and statistics, and may create secondary works such as translations and adaptations. However, where a member does not wish the Company to use such content under this Article, the member may protect their legitimate rights through the customer center.' +
    '<br><br><br>' +
    "Article 20 (Company's Disclaimer)" +
    '<br><br>' +
    'The Company is not responsible for the following:' +
    '<br>' +
    '• The truthfulness, accuracy, reliability, and utility of information posted by users on the app, and all consequences arising from use of such materials.' +
    '<br>' +
    '• Disputes occurring between members or between members and third parties mediated through the service.' +
    '<br>' +
    '• Legal disputes, liabilities, and disadvantages that may arise when users arbitrarily change prohibited modifications or fail to notify of changed contents.' +
    '<br>' +
    '• All consequences, disadvantages, and legal liabilities arising from discrepancies between the original contents described by users and the requested service contents.' +
    '<br><br>' +
    "Unless due to the Company's intentional misconduct or gross negligence, the Company is not responsible for damages arising in the following circumstances:" +
    '<br>' +
    '• Service restrictions or suspensions carried out pursuant to Article 5, paragraph 2 of these Terms and Conditions.' +
    '<br>' +
    "• Damages arising from a member's incomplete provision of personal information or failure to update necessary information." +
    '<br>' +
    '• Damages suffered by members or third parties due to intentional or negligent acts of members in accessing or using the service.' +
    '<br>' +
    '• Damages suffered by members due to natural disasters, war, civil unrest, or other force majeure events.' +
    '<br>' +
    '• Damages arising because a member failed to obtain the benefits expected from using the Site, or used information or materials obtained through the Site.' +
    '<br><br><br>' +
    'Article 21 (Posting of Advertisements)' +
    '<br><br>' +
    'To secure the financial basis for smoothly providing the best service to users, the Company may post commercial advertisements on the screen, or send them to individual users by email, SMS, app push (APP Push) message, etc. in accordance with the requirements prescribed by the Act on Promotion of Information and Communications Network Utilization and Information Protection, Etc. However, the Company will no longer send email, SMS, app push messages, etc. to a user who has clearly expressed an intention to refuse receipt.' +
    '<br><br>' +
    "The Company bears no liability whatsoever for any damage arising from a member's direct participation in the promotional activities of an advertiser through the Site." +
    '<br><br><br>' +
    'Article 22 (Dispute Resolution)' +
    '<br><br>' +
    'The Company operates a customer center to resolve disputes between members reasonably and smoothly.' +
    '<br><br>' +
    'Members must participate sincerely in dispute resolution procedures based on the principle of fairness.' +
    '<br><br><br>' +
    'Article 23 (Governing Law and Jurisdiction)' +
    '<br><br>' +
    'The governing law of the service agreement shall be the laws of the Republic of Korea.' +
    '<br><br>' +
    'Disputes or lawsuits arising between the Company and members in connection with the service agreement shall be resolved in the competent court pursuant to the Civil Procedure Act.' +
    '<br><br><br>' +
    'Article 24 (Responsibility for Products on Sale)' +
    '<br><br>' +
    'All products sold on the app/web operated by DeliveredLogistics Co., Ltd. are the responsibility of DeliveredLogistics Co., Ltd.' +
    '<br>' +
    '* Customer Complaint Contact: Kim Jong-ik / 051-742-7777',
  ja:
    '<h4>利用規約</h4>' +
    '<div>' +
    '• 本利用規約は2023年7月21日より有効となります。' +
    '<br>' +
    '• [2024年10月21日] 第19条（利用制限）- ポイント使用制限条項の追加' +
    '<br>' +
    '• [2025年5月1日] サービス運営主体の変更：グローブウェーブ株式会社 → デリバードロジスティクス株式会社' +
    '<br><br><br>' +
    '第1条（目的）' +
    '<br><br>' +
    '本規約は、デリバードロジスティクス株式会社（以下「当社」といいます）が提供するオンラインマーケットプレイス仲介サービスおよびオンラインマーケットプレイスサービスの利用に関し、当社と会員の権利・義務および責任事項を定めることを目的とします。' +
    '<br><br><br>' +
    '第2条（定義）' +
    '<br><br>' +
    '本規約で使用する用語の定義は次のとおりとし、本規約に定義のない用語の解釈は、関係法令およびサービスアプリケーション内で別途提供される指針に従います：' +
    '<br><br>' +
    'a. 「サービス」とは、当社が提供するオンラインマーケットプレイス仲介サービス、オンラインマーケットプレイスサービス、コミュニティ参加、ファン投票その他のサービスをいい、会員約款に同意した会員が電子システムにアクセスしてオンライン取引を行うことができるものをいいます。' +
    '<br><br>' +
    'b. 「サイト」とは、当社が運営するオンラインストア（https://www.giftifan.com）をいい、コンピュータおよび情報通信設備を利用して会員に物品、サービスその他の提供物を提供します。これには、当社が運営するウェブサイト、モバイルウェブおよびアプリケーションが含まれます。' +
    '<br><br>' +
    'c. 「会員」とは、当社のアプリケーションをダウンロードし、本規約に同意してサービス契約を締結し、サービスに適切に登録した利用者をいいます。' +
    '<br><br>' +
    'd. 「アイテムストア」とは、会員が物品を購入することができる空間をいいます。当社が運営するオンラインショッピングモールです。' +
    '<br><br>' +
    'e. 「商品」とは、アプリ内で使用されるオンライン製品をいい、有効期限および利用制限に関する詳細はサービス画面上に表示されます。' +
    '<br><br>' +
    'f. 「会員情報」とは、サービス品質維持のために必要な情報（ニックネーム、メールアドレス）をいいます。' +
    '<br><br>' +
    'g. 「ポイント」とは、サイトにおいて商品等を購入する際に決済手段として利用できるものをいい、会員が有償で購入する「有料ポイント」と、当社がイベント、プロモーション等を通じて無償で付与する「無料ポイント」に区分されます。' +
    '<br><br><br>' +
    '第3条（規約の効力）' +
    '<br><br>' +
    '当社は、本規約に定めのない事項を補完し運用するため、個別ポリシー等の別途の方針（以下「ポリシー」といいます）を制定することができます。当社は当該ポリシーをウェブサイトに掲示します。当該ポリシーは本規約とともにサービス利用規約（以下「サービス利用規約」といいます）の一部を構成します。会員による本規約およびポリシーへの同意は、サービス利用規約への署名と同一の効力を有します。' +
    '<br><br>' +
    '当社は、特定のサービスについて別途の規約（以下「個別規約」といいます）を制定することができます。会員が個別規約に同意した場合、個別規約はサービス利用規約の一部を構成します。個別規約と本規約の内容が抵触する場合、個別規約が優先して適用されます。' +
    '<br><br><br>' +
    '第4条（規約の掲示および改定）' +
    '<br><br>' +
    '当社は、本規約の内容、商号、代表者の氏名、営業所所在地、電話番号、電子メールアドレスおよび事業者登録番号を、会員が容易に確認できるよう、ウェブサイトのサービス初期画面に掲示します。当社は、ホームページ上のリンク画面を通じて、会員が容易に本規約にアクセスし確認できるようにします。' +
    '<br><br>' +
    '当社は、関係法令に違反しない範囲で、本規約およびポリシーを改定することができます。この場合、当社は、改定内容および効力発生日を、効力発生日の7日前から効力発生日の前日まで、ホームページを通じて告知します。ただし、変更内容が会員に不利となる場合は、改定された規約およびポリシーを効力発生日の30日前から効力発生日まで告知します。' +
    '<br><br>' +
    '関係法令の改正に伴う本規約またはポリシーの改定など、緊急かつやむを得ない事情により本文のとおりの告知が困難な場合、当社は、効力発生日までに第1項本文と同一の方法により、改定された規約またはポリシーを公示します。' +
    '<br><br>' +
    '会員が改定された規約またはポリシーに同意しない場合、会員は、効力発生日の前日までに拒絶の意思を表示し、利用契約を解除することができます。この場合、未使用の有料ポイント等の会員の権利は、第15条および第17条に従って精算・払戻されます。' +
    '<br><br>' +
    '当社が本条に基づき改定された規約またはポリシーを公示または通知し、会員が効力発生日までに意思表示をしない場合、会員は改定された規約またはポリシーに同意したものとみなされます。' +
    '<br><br>' +
    '改定された規約は、会員に有利な場合を除き、その効力発生日より前の日付に遡って適用されません。' +
    '<br><br>' +
    '本規約に定めのない事項およびその解釈については、「電子商取引等における消費者保護に関する法律」、「約款の規制に関する法律」、公正取引委員会が定める「電子商取引等における消費者保護指針」その他の関係法令または商慣行によります。' +
    '<br><br><br>' +
    '第5条（サービスの提供および中断）' +
    '<br><br>' +
    '当社が本規約に基づき提供するサービスの種類は次のとおりです：' +
    '<br>' +
    '• オンラインコマースサービスおよびその他関連サービス。' +
    '<br>' +
    '• オンラインコマース仲介サービスおよびその他関連サービス。' +
    '<br>' +
    '• 上記サービスの提供に必要または関連する付加サービス。' +
    '<br><br>' +
    'サービスは、原則として年中無休、1日24時間提供します。ただし、当社は、コンピュータその他の情報通信設備の保守点検、交換、故障、通信の途絶、運営上もしくは技術上の支障、技術的改善その他相当な運営上の事由がある場合、サービスの提供を一時的または恒久的に中断することができ、その変更内容をウェブサイトを通じて告知します。' +
    '<br><br>' +
    '第2項にかかわらず、当社はサービスを特定の範囲に区分し、各範囲ごとに別途の運営時間を定めることができます。詳細はホームページを通じて告知します。' +
    '<br><br>' +
    '当社が事業の変更、廃業、合併、分割、譲渡その他の事由によりサービスを提供することができない場合、当社は関係法令を遵守します。関係法令に別段の定めがない限り、会員に対して別途の補償は行いません。' +
    '<br><br><br>' +
    '第6条（会員登録）' +
    '<br><br>' +
    '利用者は無料で会員登録を行うことができ、当社所定の登録フォームに会員情報を入力し、本規約および個人情報の収集・提供・利用への同意を表示することにより、会員登録を申請します。' +
    '<br><br>' +
    '第1項に基づき会員登録を申請した利用者について次のいずれかに該当する事由が認められる場合、当社は当該事由が解消されるまで会員登録を拒否することができます：' +
    '<br>' +
    '1. 申請者が、本規約第7条第3項に基づき従前に会員資格を喪失したことがある場合;' +
    '<br>' +
    '2. 登録内容に虚偽、記載漏れまたは誤りがある場合;' +
    '<br>' +
    '3. 第7条第3項各号の事由が存する場合または存するおそれがある相当の理由がある場合;' +
    '<br>' +
    '4. その他、当該利用者を会員として登録することが当社の運営上または技術上著しい支障となると判断される場合。' +
    '<br><br>' +
    '満14歳未満の児童は会員登録を制限します。' +
    '<br><br>' +
    '会員登録は、当社の承諾が登録を申請した利用者に到達した時点で完了します。' +
    '<br><br><br>' +
    '第7条（会員の退会および会員資格の停止または喪失）' +
    '<br><br>' +
    '会員はいつでも当社に退会を申請することができ、会員から退会の申請があった場合、当社は直ちに退会に必要な措置を講じます。ただし、次の各号の場合、当社は、当該事由が解消されるまで会員の退会を制限することができます：' +
    '<br>' +
    '1. 入金待ちまたは注文受付状態の注文がある場合;' +
    '<br>' +
    '2. 交換、返品、再配送、賠償、返金等の決済処理が進行中の場合。' +
    '<br><br>' +
    '会員は、退会を申請する前に、すべての取引を完了させるために必要な措置を講じなければなりません。これを行わないまま退会した場合、不利益が生じる場合があります。オンラインストアの利用に関連する債権債務関係が残存する場合、当社は、債権回収および弁済等の目的のために個人情報を利用することができ、法令に特別の定めがある場合は、当該法令に定める目的および期間の範囲内で個人情報を保有することができます。' +
    '<br><br>' +
    '会員が次のいずれかに該当する場合、当社は、当該会員に対し関連事由を通知した上で、会員資格を停止または喪失させることができます。会員資格が停止または喪失した場合、すべての会員特典は消滅します：' +
    '<br>' +
    '• 会員がサイトを通じて購入した商品の代金その他当社の利用に関連して負担する債務を、その期日までに履行しない場合;' +
    '<br>' +
    '• 会員が、サイトの利用に関連して、法令もしくは本規約に違反する行為または公序良俗に反する行為を行った場合;' +
    '<br>' +
    '• その他、当社の合理的な判断において、当該会員に対するサイトサービスの提供を拒否することが必要であると認められる場合;' +
    '<br>' +
    '• 会員が、会員情報に虚偽の情報を入力し、または他人の情報を不正に利用した場合;' +
    '<br>' +
    '• 会員の責めに帰すべき事由（会員情報の誤入力または正確な情報への更新の懈怠等）により、当社が相当の努力を払ったにもかかわらず会員への通知または連絡ができない場合;' +
    '<br>' +
    '• サイトの運営に関連するやむを得ない運営上または技術上の必要もしくは事由により、サイトの利用に著しい支障が生じる場合;' +
    '<br>' +
    '• 本条に基づき会員資格を停止または喪失した会員が、不正な方法により再度会員登録を行った場合。' +
    '<br><br>' +
    '当社は、第3項に基づき会員資格を停止または喪失させる場合、会員に対し当該停止または喪失の事実および事由を通知し、30日間の疎明の機会を付与することができます。' +
    '<br><br>' +
    '当社は、第5項の会員の疎明に正当な理由があると認める場合、会員資格の停止または喪失を撤回することができます。' +
    '<br><br>' +
    '会員が第1項により退会した場合、または当社が第3項により会員資格を喪失させた場合、当社は当該会員の登録を削除し、個人情報を破棄します。ただし、法令に特別の定めがある場合は、当該法令に定める目的および期間の範囲内で、会員の個人情報を引き続き保有することができます。' +
    '<br><br>' +
    '当社は、会員の個人情報を保護するため、オンラインストアへの最終ログインから1年間ログイン記録がない会員について、利用契約の解約および個人情報の破棄等、退会に必要な措置を講じます。この場合、当社は、利用契約の解約および個人情報の破棄について、解約の30日前までに、本規約第23条に定める方法により告知します。' +
    '<br><br><br>' +
    '第8条（サービスの利用）' +
    '<br><br>' +
    '会員は、本規約およびサービス画面において当社が掲示する各種の通知事項を遵守しなければなりません。会員は、本規約および掲示された通知事項に違反し、またはこれを遵守しなかったことにより生じたすべての損害について全責任を負います。' +
    '<br><br>' +
    '会員は、当社または他の会員との紛争が発生した場合、誠実に紛争解決に努めなければなりません。会員が紛争解決において誠実性を欠いたことにより、当社または第三者に損害を生じさせた場合、その損害について全責任を負います。' +
    '<br><br>' +
    '当社は、取引に使用される決済手段について、会員が適切な権限を有しているかを確認することができ、確認が完了するまで取引を停止することができます。会員がサービスの本来の目的に違反する行為を行ったと認められる場合、当社は、疎明を求め、購入取消等の必要な措置を講じることができます。未成年者が法定代理人の同意なく商品またはサービスを購入した場合、未成年者本人または法定代理人は契約を取り消すことができます。' +
    '<br><br><br>' +
    '第9条（当社の義務）' +
    '<br><br>' +
    '当社は、継続的かつ安定的にサービスを提供するため最善の努力を尽くし、本規約、関係法令または公序良俗に反する行為を行いません。' +
    '<br><br>' +
    '当社は、本規約で定める場合を除き、会員の同意なく会員情報を第三者に提供しません。' +
    '<br><br>' +
    '当社は、会員の個人情報を保護し、安全なサービス利用を確保するため、セキュリティシステムを構築し維持します。当社は、個人情報処理方針を公開し、これを遵守します。当社は、会員の同意なく営利目的のメール、アプリ内プッシュ通知その他の宣伝物を送信しません。' +
    '<br><br>' +
    '当社は、会員の意見または苦情が客観的に正当と認められる場合、これを迅速に解決するよう努めます。迅速な処理が困難な場合、当社は、サービス画面への掲示、メールその他の電子的手段により会員に通知します。' +
    '<br><br>' +
    '当社が会員に対して通知を行う場合、当社と会員との間に別段の合意がない限り、会員がオンラインストアに加入し利用する際に登録したメールアドレス、電話、SMS、アプリプッシュ（APP Push）メッセージ等の方法により送信します。' +
    '<br><br>' +
    '不特定多数の会員に対する通知は、当社がオンラインストアの画面に1週間以上掲示することにより、個別通知に代えることができます。ただし、会員自身のオンラインストア関連取引等、会員の管理関係に重大な影響を及ぼす事項については、当社は第5項に従って当該会員に個別に通知します。' +
    '<br><br><br>' +
    '第10条（会員の義務）' +
    '<br><br>' +
    '会員は、当社の規約、規程、サービス方針、利用案内および関係法令を遵守しなければならず、当社の業務を妨げる行為を行ってはなりません。' +
    '<br><br>' +
    '会員は、次の各号の行為を行ってはなりません：' +
    '<br>' +
    '• 当社が提供するサービスを利用せずに会員間で直接取引を行う行為またはこれを誘発する行為。' +
    '<br>' +
    '• 当社または他の会員の活動を妨害する行為、不当な利益を得る行為等、通常の取引慣行に反する不正行為または取引。' +
    '<br>' +
    '• 「特定金融情報法」（特定金融取引情報の報告および利用等に関する法律）、「情報通信網利用促進及び情報保護等に関する法律」その他関係法令に違反する異常な決済行為。' +
    '<br>' +
    '• 当社が提供する方法と異なる異常な方法でサービスを利用し、または当社の情報処理システムに無断でアクセスする行為。' +
    '<br>' +
    '• 当社もしくは第三者の権利を侵害し、もしくは侵害するおそれのある行為、または商取引秩序を脅かす行為。' +
    '<br>' +
    '• 申請または変更にあたり虚偽の内容を登録する行為;' +
    '<br>' +
    '• 他人の情報を不正に利用する行為;' +
    '<br>' +
    '• サイトに掲示された情報の無断改変;' +
    '<br>' +
    '• 当社が指定する情報以外の情報（コンピュータプログラム等）の送信または掲示;' +
    '<br>' +
    '• 当社または第三者の著作権その他の知的財産権を侵害する行為;' +
    '<br>' +
    '• 当社または第三者の名誉を毀損し、またはその業務を妨害する行為;' +
    '<br>' +
    '• わいせつもしくは暴力的なメッセージ、画像もしくは音声、虚偽の映像資料、児童・青少年の性的搾取物、その他公序良俗に反する情報をプラットフォーム上に公開し、または掲示する行為;' +
    '<br>' +
    '• 当社が提供するサービスの正常な運営を妨げる異常な決済または不正利用行為。' +
    '<br><br>' +
    '会員が第2項に違反した場合、当社は、解約、商品の没収、会員資格の制限、カード決済の取消もしくは停止、その他民事上・刑事上の法的措置を講じることができます。' +
    '<br><br><br>' +
    '第11条（商品）' +
    '<br><br>' +
    '商品は、アプリ内で使用されるオンライン製品であり、有効期限および利用制限に関する詳細はサービス画面上に表示されます。価格は、為替変動または当社のサービス方針に応じて変更されることがあります。購入から7日を経過した商品は、取消・返金ができず、有効期間の経過または会員資格の喪失により失効します。' +
    '<br><br>' +
    '当社が別途定める場合を除き、商品は他人に譲渡することはできず、違法または不正な目的に使用することはできません。違反した場合、当社は当該商品を無効とし、会員資格を制限または喪失させることができます。' +
    '<br><br>' +
    '会員が不正な方法により商品を取得したと認められる場合、当社は当該商品を取り消し、会員資格の喪失、民事・刑事上の訴訟等の法的措置を講じることができます。' +
    '<br><br><br>' +
    '第12条（購入申込）' +
    '<br><br>' +
    '会員は、本規約と類似のまたは本規約に定める方法により、購入申込を行うことができます。利用者が購入申込を行う場合、当社は、次の事項を分かりやすい方法で提供します：' +
    '<br>' +
    '• 商品または品目の検索および選択;' +
    '<br>' +
    '• 受取人の氏名、住所、電話番号およびメールアドレス（または携帯電話番号）の入力（海外配送先の場合は英語で記載）;' +
    '<br>' +
    '• 商品説明、サービスの利用制限、配送料・設置料等の費用の確認;' +
    '<br>' +
    '• 商品購入申込内容の確認および当社による確認への同意;' +
    '<br>' +
    '• 規約の内容、撤回権が制限されるサービス、配送料等の費用負担に関する事項の確認;' +
    '<br>' +
    '• 本規約への同意ならびに上記第5項の事項の確認または拒否の表示;' +
    '<br>' +
    '• 決済方法の選択。' +
    '<br><br>' +
    '当社は、次の場合、購入申込を拒否することができます：' +
    '<br>' +
    '• 申込内容に虚偽、記載漏れまたは誤りがある場合;' +
    '<br>' +
    '• 未成年者が「青少年保護法」により禁止される商品もしくはサービス（たばこ、酒類等）を購入しようとする場合;' +
    '<br>' +
    '• 申込を承諾することが当社の技術上の能力に著しく支障を及ぼす場合。' +
    '<br><br>' +
    '当社は、購入者の個人情報を第三者に提供し、またはその取扱いを委託する必要がある場合、関係法令に従い、購入者に通知し、必要な同意を得ます。' +
    '<br><br><br>' +
    '第13条（契約の成立）' +
    '<br><br>' +
    '当社は、第12条の購入申込について、次のいずれかに該当する場合、その承諾を拒否することができます：' +
    '<br>' +
    '• 申込内容に虚偽、記載漏れまたは誤りがある場合;' +
    '<br>' +
    '• 未成年者が関係法令により禁止される商品等を購入しようとする場合;' +
    '<br>' +
    '• その他、申込の承諾が当社の技術上著しい支障を及ぼすと判断される場合。' +
    '<br><br>' +
    '契約は、受領確認の通知形式による当社の承諾が利用者に到達した時に成立したものとみなします。' +
    '<br><br><br>' +
    '第14条（決済方法）' +
    '<br><br>' +
    '当社は、利用者が購入した商品の代金の決済について、次のいずれかの方法を提供することができます。ただし、決済方法は、当社の内部方針および運営上または技術上の事由により変更されることがあります：' +
    '<br>' +
    '1. 電話バンキング、インターネットバンキング等の各種口座振替;' +
    '<br>' +
    '2. プリペイドカード、デビットカード、クレジットカード等の各種カード決済;' +
    '<br>' +
    '3. 電子通貨による決済;' +
    '<br>' +
    '4. 当社と契約を締結したまたは当社が認める商品券による決済;' +
    '<br>' +
    '5. その他の電子的支払手段による決済。' +
    '<br><br>' +
    '当社は、内部方針、外部決済事業者（銀行、カード会社等）および関係法令の変更等に応じて、利用者の購入金額について、月間累計決済額、決済上限額等の取引限度を設定することができ、利用者が当該限度を超えて商品を購入しようとする場合、取引限度を超過することにより購入ができないことがあります。' +
    '<br><br><br>' +
    '第15条（受領確認通知および購入申込の変更または取消）' +
    '<br><br>' +
    '本規約第12条の利用者による購入申込があった場合、当社は利用者に対し受領確認の通知を行います。' +
    '<br><br>' +
    '受領確認の通知を受けた利用者は、意思表示に齟齬がある場合、通知受領後直ちに購入申込の変更または取消を請求することができ、当社は、商品の準備（出荷指示等）および引渡し前に利用者からの請求があった場合、その請求に従い遅滞なく処理します。ただし、商品が既に出荷指示等により準備された場合、または引渡しが完了している場合は、利用者の請求に従った処理が困難であることがあり、この場合は本規約第17条の購入申込の撤回等に関する規定が適用されます。' +
    '<br><br>' +
    '購入取消に伴う返金は、関連する決済手続が完了次第、行います。' +
    '<br><br>' +
    '決済時に割引クーポンが使用されていた場合、当該クーポンの利用は取り消されます。ただし、クーポンの有効期限が経過している場合は、返金と同時に失効として処理されます。' +
    '<br><br>' +
    'パッケージとして購入した商品の一部を使用した場合、一部返金はできません。商品が未使用のまま、購入から7日以内に取消の意思を表示した場合、本人確認後、返金額から返金手数料（返金額の10%）を控除した金額で返金処理を行うことができます。' +
    '<br><br><br>' +
    '第16条（配送および取引の完了）' +
    '<br><br>' +
    '会員は、購入した商品または品目の引渡しが完了した日から一定期間（7日）以内に、購入、交換または返品等に関する意思表示を行わなければなりません。' +
    '<br><br>' +
    '会員が第1項の期間内に購入、交換または返品の意思表示を行わない場合、当社は、当該会員が購入を自動確定する意思表示を行ったものとみなし、当該取引について自動購入確定処理を行うことができます。' +
    '<br><br><br>' +
    '第17条（撤回権）' +
    '<br><br>' +
    '当社と商品もしくは製品の購入契約を締結した会員は、「電子商取引法」その他の関係法令に従い、商品または製品が供給された日から7日以内に返品または交換を申請することができます。ただし、「電子商取引法」に申込の撤回について特別の定めがある場合は、当該規定によります。' +
    '<br><br>' +
    '第1項にかかわらず、会員は、次の場合、返品または交換を請求することができません：' +
    '<br>' +
    '• 会員の責めに帰すべき事由により商品が滅失または毀損した場合（内容物を確認するために包装を毀損した場合を除く）。' +
    '<br>' +
    '• 会員の使用または一部消費により商品の価値が著しく減少した場合。' +
    '<br>' +
    '• 時の経過により再販売が困難となる程度に商品の価値が著しく減少した場合。' +
    '<br>' +
    '• 複製可能な商品の包装が毀損された場合。' +
    '<br>' +
    '• 「文化産業振興基本法」第2条第5号に基づくサービスまたはデジタルコンテンツの提供が開始された場合。' +
    '<br>' +
    '• 個別に注文生産された商品について、申込の撤回により製造業者に回復不可能な重大な損害が生じる場合であって、利用者に別途その旨を告知し、書面による事前同意を得ている場合。' +
    '<br>' +
    '• その他関係法令に基づき返品制限事由がある場合。' +
    '<br><br>' +
    '第1項および第2項にかかわらず、商品の内容が表示・広告と異なり、または契約と異なる方法で履行された場合、会員は、当該商品の引渡日から3か月以内、または当該事実を知った日もしくは知り得た日から30日以内に、返品または交換を申請することができます。' +
    '<br><br>' +
    '会員が交換を申請したが、当社に交換対象商品の在庫がない場合、会員は交換を受けることができません。この場合、製造業者は、利用者の意思を確認した上で、当該交換申請を返品として処理することができます。' +
    '<br><br>' +
    '返品または交換に伴う送料その他の費用は、責に帰すべき当事者が負担します。商品の瑕疵または誤配送による返品または交換の費用は当社が負担し、会員の単純な変心による返品または交換の費用は会員が負担します。' +
    '<br><br>' +
    '当社が会員の返品または交換の請求を拒否する場合、当該注文は自動的に購入確定に転換されます。' +
    '<br><br><br>' +
    '第18条（利用制限）' +
    '<br><br>' +
    '当社は、当社が提供するサイト等を利用する会員が、快適かつ安全に体験できるよう、本規約およびポリシーに違反する会員の利用を制限する措置を、通報活動を通じて実施しています。' +
    '<br><br>' +
    '次の行為は、利用制限措置の事由となることがあります：' +
    '<br>' +
    '• わいせつなコンテンツの送信もしくは掲示、または違法なギャンブルサイトの宣伝;' +
    '<br>' +
    '• 違法録画物、虚偽の映像資料または児童性的搾取物の共有;' +
    '<br>' +
    '• 他人の個人情報および権利の公開または侵害;' +
    '<br>' +
    '• 他人のアカウントの乗っ取り;' +
    '<br>' +
    '• 他人に対する名誉毀損、悪口、または他人に関する未確認情報の共有;' +
    '<br>' +
    '• その他の例外的な事情。' +
    '<br><br>' +
    '利用制限措置が適用される場合、特定の機能または当社の全サービスへのアクセスが制限されることがあります。' +
    '<br><br>' +
    '会員は、利用制限措置を受けた場合、カスタマーサポートセンターに連絡し、当該措置の理由および不便を解消する方法に関する情報を入手してください。' +
    '<br><br>' +
    'クーポンおよびポイントは、保有者本人のみが使用することができ、第三者に代わって使用すること、または金銭的対価と引き換えに他人に提供することは禁止されます。違反した場合、当社は、当該ポイントまたはクーポンを没収し、アカウントを停止し、サービスの利用を制限することができます。' +
    '<br><br><br>' +
    '第19条（権利の帰属）' +
    '<br><br>' +
    '① 当社が提供するサービスに関する権利（データ、ソフトウェアおよび投稿物に関する著作権を含みます）は、当社に帰属します。' +
    '<br><br>' +
    '② 会員は、当社の事前の同意なく、当社が保有する著作権その他の知的財産権を、複製、送信、出版、配布、放送その他の方法により利用し、または第三者に利用させることにより、これを侵害してはなりません。' +
    '<br><br>' +
    '③ 会員は、当社の事前の同意なく、サイトの利用を通じて知り得た情報を、複製、送信、出版、配布、放送その他の方法により営利目的で利用し、または第三者に利用させてはなりません。' +
    '<br><br>' +
    '④ 顧客商品レビュー等、会員が直接登録する投稿物の著作権は、これを作成した会員に帰属し、当該投稿物に関する著作権侵害等を含む民事上・刑事上のすべての責任は、当該会員が負います。ただし、当社に故意または重大な過失がある場合は、当社がその責任を負います。' +
    '<br><br>' +
    '⑤ 当社は、第3項に基づき、会員が登録した投稿物を、検索結果その他のサイトでの表示、宣伝・広報等の素材として、無償で利用することができます。ただし、投稿物を登録した会員が、当該投稿物の削除とともに利用の中止を請求する場合、当社は直ちにその利用を中止します。' +
    '<br><br>' +
    '⑥ 顧客商品レビュー等、会員が登録した投稿物が、次のいずれかに該当する場合、当社は、当該利用者に事前通知することなく、当該投稿物を非表示または削除することができます：' +
    '<br>' +
    '1. 法令に違反し、または公序良俗に反する内容を含む場合;' +
    '<br>' +
    '2. 虚偽または誇大広告の内容を含む場合;' +
    '<br>' +
    '3. 政治的、社会的または経済的な紛争を引き起こすおそれのある内容を含む場合;' +
    '<br>' +
    '4. 当該商品の評価と関係のない内容を含む場合;' +
    '<br>' +
    '5. 直接取引を誘発し、または他のサイトへのリンクを掲示・宣伝する場合;' +
    '<br>' +
    '6. 当社を含む第三者の権利、個人情報、名誉、信用その他の正当な権利または利益を侵害する場合;' +
    '<br>' +
    '7. 特定の単語または語句を反復的に挿入し、または意味のない特殊記号、記号もしくは外国語で作成された場合;' +
    '<br>' +
    '8. 当社が提供する方法以外の異常な方法により作成・掲示された場合;' +
    '<br>' +
    '9. 特定の商品について、在庫切れ、技術仕様の変更等により販売が中止され、当該商品の提供が不可能となった場合;' +
    '<br>' +
    '10. サイトの運営に関し、運営上または技術上の必要もしくは事由があると当社が合理的に判断する場合;' +
    '<br>' +
    '11. 当社が提供するサイトサービスの円滑な提供を妨げる場合。' +
    '<br><br>' +
    '当社は、顧客商品レビュー、顧客アンケート、当社に提出された意見等の内容について、サービス改善、宣伝、商品開発、統計等の目的のため、無償でこれを利用、公開、掲示、複製、送信等することができ、翻訳、翻案等の二次的著作物を作成することができます。ただし、会員が本条に基づく当社の利用を望まない場合、会員は、カスタマーセンターを通じて自己の正当な権利を保護することができます。' +
    '<br><br><br>' +
    '第20条（当社の免責）' +
    '<br><br>' +
    '当社は、次の事項について責任を負いません：' +
    '<br>' +
    '• 利用者がアプリに掲示した情報の真実性、正確性、信頼性および有用性、ならびに当該資料の利用から生じるすべての結果。' +
    '<br>' +
    '• 会員間または会員と第三者との間でサービスを介して発生する紛争。' +
    '<br>' +
    '• 利用者が禁止される変更を任意に行い、または変更内容を通知しなかったことにより生じうる法的紛争、責任および不利益。' +
    '<br>' +
    '• 利用者が記載した原内容と要請したサービス内容との齟齬から生じるすべての結果、不利益および法的責任。' +
    '<br><br>' +
    '当社の故意または重大な過失による場合を除き、当社は、次の各号の事情により生じた損害について責任を負いません：' +
    '<br>' +
    '• 本規約第5条第2項に基づき行われたサービスの制限または中断。' +
    '<br>' +
    '• 会員の個人情報の提供の不備または必要情報の更新の懈怠により生じた損害。' +
    '<br>' +
    '• 会員のサービス接続もしくは利用における故意または過失行為により、会員または第三者が被った損害。' +
    '<br>' +
    '• 天災地変、戦争、内乱その他の不可抗力により会員が被った損害。' +
    '<br>' +
    '• 会員がサイトの利用により期待した利益を得られず、またはサイトを通じて取得した情報もしくは資料を利用したことにより生じた損害。' +
    '<br><br><br>' +
    '第21条（広告の掲載）' +
    '<br><br>' +
    '当社は、利用者に最良のサービスを円滑に提供するための財政的基盤を確保するため、画面上に商業広告を掲載し、または「情報通信網利用促進及び情報保護等に関する法律」が定める要件に従い、メール、SMS、アプリプッシュ（APP Push）メッセージ等により個別の利用者に送信することができます。ただし、当社は、受信拒否の意思を明確に表示した利用者に対しては、メール、SMS、アプリプッシュメッセージ等を送信しません。' +
    '<br><br>' +
    '当社は、会員がサイトを通じて広告主の販促活動に直接参加したことにより生じた損害について、一切責任を負いません。' +
    '<br><br><br>' +
    '第22条（紛争解決）' +
    '<br><br>' +
    '当社は、会員間の紛争を合理的かつ円滑に解決するため、カスタマーセンターを運営します。' +
    '<br><br>' +
    '会員は、公正の原則に基づき、誠実に紛争解決手続に参加しなければなりません。' +
    '<br><br><br>' +
    '第23条（準拠法および管轄）' +
    '<br><br>' +
    'サービス契約の準拠法は、大韓民国の法律とします。' +
    '<br><br>' +
    'サービス契約に関連して当社と会員との間に発生した紛争または訴訟は、民事訴訟法に従い、管轄裁判所において解決します。' +
    '<br><br><br>' +
    '第24条（販売商品に対する責任の所在）' +
    '<br><br>' +
    'デリバードロジスティクス株式会社が運営するアプリ／ウェブにおいて販売されるすべての商品は、デリバードロジスティクス株式会社が責任を負います。' +
    '<br>' +
    '* 苦情相談窓口：キム・ジョンイク / 051-742-7777' +
    '<br><br>' +
    'お問い合わせ：' +
    '<br>' +
    '電話番号：+82 10 5963 1771' +
    '<br>' +
    'メール：store@giftifan.com' +
    '<br><br>' +
    '決済は第三者決済代行会社、Eromnet Co., Ltd（〒06193 大韓民国ソウル市江南区テヘラン路414、10階）が処理します。',
};

const privacyTerm = {
  ko:
    '<h4>개인정보 처리방침</h4>' +
    '<br><br>' +
    '<div>' +
    '※ 2025년 5월 1일부로 개인정보 처리 주체가 글로브웨이브 주식회사에서 주식회사 딜리버드로지스틱스로 변경되었습니다.' +
    '<br><br><br>' +
    '제1조(목적)' +
    '<br><br>' +
    '주식회사 딜리버드로지스틱스(이하 "회사"라 한다)는 회사가 제공하고자 하는 서비스(이하 "회사서비스"라 한다)를 이용하는 개인(이하 "이용자" 또는 "개인"이라 한다)의 정보(이하 "개인정보"라 한다)를 보호합니다. 개인정보보호법 및 정보통신망 이용촉진 및 정보보호 등에 관한 법률(이하 "정보통신망법"이라 한다) 등 관련 법령을 준수하고 개인정보보호와 관련된 서비스 이용자의 고충을 신속하고 원활하게 처리하기 위하여 다음과 같이 개인정보 처리방침(이하 "이 방침"이라 한다)을 수립합니다.' +
    '<br><br><br>' +
    '제2조(개인정보처리의 원칙)' +
    '<br><br>' +
    '1. 개인정보 관련 법률 및 본 정책에 따라 회사는 이용자의 개인정보를 수집할 수 있으며, 수집된 개인정보는 개인의 동의가 있어야 제3자에게 제공할 수 있습니다. 단, 회사는 「개인정보 보호법」, 「정보통신망 이용촉진 및 정보보호 등에 관한 법률」, 「통신비밀보호법」, 「전기통신사업법」, 「전자상거래 등에서의 소비자보호에 관한 법률」, 「국세기본법」, 「신용정보의 이용 및 보호에 관한 법률」, 「소비자기본법」, 「자살예방 및 생명존중문화 조성을 위한 법률」, 「제품안전기본법」 등 다른 법률 및 규정 등이 있는 경우 법률에서 규정한 적법한 절차에 따라 제3자에게 이용자의 개인정보를 제공할 수 있습니다. 특히, 회사는 재난, 감염병, 급박한 생명·신체 위험을 초래하는 사건·사고, 급박한 재산 손실 등의 긴급 상황이 발생하는 경우 이용자의 동의 없이 관계기관에 개인정보를 제공할 수 있습니다.' +
    '<br><br>' +
    '2. 회사는 원활한 서비스 제공을 위하여 개인정보 처리업무를 위탁하여 처리할 수 있습니다. 회사는 처리업무 위탁 시 「개인정보 보호법」 제26조에 따라 위탁업무 수행목적 외 개인정보 처리금지, 기술적·관리적 보호조치, 재위탁 제한, 수탁자에 대한 관리·감독, 손해배상책임 등에 관한 사항을 계약서 등 문서에 명시하고, 수탁자가 개인정보를 안전하게 처리하는지를 관리·감독하고 있습니다.' +
    '<br><br><br>' +
    '제3조(이 규정의 공시)' +
    '<br><br>' +
    '1. 회사는 이용자가 언제든지 쉽게 이 정책을 확인할 수 있도록 회사 홈페이지의 첫 화면이나 첫 화면 링크를 통해 이 정책을 공개합니다.' +
    '<br>' +
    '2. 회사는 제1항에 따라 본 정책을 공개할 때, 이용자가 본 정책을 쉽게 확인할 수 있도록 글꼴 크기, 색상 등을 사용합니다.' +
    '<br><br><br>' +
    '제4조(이 정책의 변경)' +
    '<br><br>' +
    '1. 본 정책은 개인정보 관련 법령, 지침, 고시 또는 정부 또는 회사 서비스의 정책이나 내용 등의 변경에 따라 개정될 수 있습니다.' +
    '<br>' +
    '2. 회사는 제1항에 따라 본 약관을 개정하는 경우 다음 중 하나 이상의 방법으로 고시할 예정입니다.' +
    '<br>' +
    'a. 회사 인터넷 홈페이지 첫 화면의 공지란을 통해 공지하거나 별도의 창을 통해 공지하는 방법' +
    '<br>' +
    'b. 서면, 팩시밀리, 이메일 또는 이와 유사한 방법으로 이용자에게 통지하는 방법' +
    '<br>' +
    '3. 회사는 본 정책의 개정 시행일 최소 7일 전에 제2항에 공고할 예정입니다. 다만, 이용자 권리에 중대한 변동이 있는 경우에는 최소 30일 전에 공고할 예정입니다.' +
    '<br><br><br>' +
    '제5조(회원가입을 위한 정보)' +
    '<br><br>' +
    '회사는 이용자가 회사의 서비스를 등록할 수 있도록 하기 위해 다음과 같은 정보를 수집합니다.' +
    '<br>' +
    '1. 필수수집정보 : 이메일주소 및 닉네임' +
    '<br><br><br>' +
    '제6조(회사의 서비스 제공을 위한 정보)' +
    '<br><br>' +
    '회사는 이용자에게 회사의 서비스를 제공하기 위해 다음과 같은 정보를 수집합니다.' +
    '<br>' +
    '1. 필수수집정보 : 아이디 및 이메일주소' +
    '<br><br><br>' +
    '제7조(서비스 이용 및 부정 이용 확인을 위한 정보)' +
    '<br><br>' +
    '회사는 이용자의 서비스 이용 및 서비스 오용을 확인하고 분석하기 위해 다음과 같은 정보를 수집합니다.' +
    '<br>' +
    '1. 필수수집정보 : 서비스 이용기록' +
    '<br><br><br>' +
    '제8조(개인정보 수집방법)' +
    '<br><br>' +
    '회사는 다음과 같은 방법으로 이용자의 개인정보를 수집합니다.' +
    '<br>' +
    '1. 이용자가 회사 홈페이지에 개인정보를 입력하는 방법' +
    '<br>' +
    '2. 이용자가 애플리케이션 등 회사가 제공하는 웹사이트 이외의 서비스를 통하여 개인정보를 입력하는 방법' +
    '<br><br><br>' +
    '제9조(개인정보의 이용)' +
    '<br><br>' +
    '회사는 다음의 경우 개인정보를 활용합니다.' +
    '<br>' +
    '1. 이용문의 대응, 민원처리 등 이용자를 위한 서비스 개선' +
    '<br>' +
    '2. 회사의 서비스 제공' +
    '<br>' +
    '3. 인구통계학적 분석, 서비스 방문 및 이용 기록 분석' +
    '<br>' +
    '4. 법령 및 회사약관을 위반한 회원의 이용제한, 부정사용 등 서비스의 원활한 운영을 방해하는 행위를 예방하고 제재하기 위함입니다.' +
    '<br><br><br>' +
    '제10조(개인정보의 보유 및 이용기간)' +
    '<br><br>' +
    '1. 회사는 개인정보 수집 및 이용 목적을 달성하기 위하여 이용자의 개인정보를 해당 기간 동안 보유·이용합니다.' +
    '<br>' +
    '2. 전항에도 불구하고 회사 내부 방침에 따라 불법적인 서비스 이용 기록은 회원 탈퇴 시점부터 최대 1년간 보관하여 불법 등록 및 이용을 방지하고 있습니다.' +
    '<br><br><br>' +
    '제11조(개인정보의 법에 따른 보유 및 이용기간)' +
    '<br><br>' +
    '회사는 관련 법규에 따라 아래와 같이 개인정보를 보유 및 이용하고 있습니다.' +
    '<br>' +
    '1. 전자상거래 등에서의 소비자보호에 관한 법률에 따른 정보 및 보유기간' +
    '<br>' +
    '- 계약 또는 청약취소 등에 관한 기록 : 5년' +
    '<br>' +
    '- 물품대금지급 및 공급실적 등 : 5년' +
    '<br>' +
    '- 소비자불만 또는 분쟁해결 실적 : 3년' +
    '<br>' +
    '- 표시 및 광고 관련 기록 : 6개월' +
    '<br>' +
    '2. 통신비밀보호법에 따른 정보의 보유 및 보유기간' +
    '<br>' +
    '- 웹사이트 로그 자료 : 3개월' +
    '<br>' +
    '3. 전자금융거래법에 따른 정보 및 보유기간' +
    '<br>' +
    '- 전자금융거래 실적 : 5년' +
    '<br>' +
    '4. 위치정보 등의 보호 및 이용에 관한 법률' +
    '<br>' +
    '- 개인위치정보 기록 : 6개월' +
    '<br><br><br>' +
    '제12조(개인정보 파기의 원칙)' +
    '<br><br>' +
    '이용자의 개인정보 처리 목적을 달성하였거나 보유·이용 기간이 만료된 경우 등 더 이상 개인정보가 필요하지 않을 때는 지체 없이 파기하는 것을 원칙으로 합니다.' +
    '<br><br><br>' +
    '제13조(서비스 미이용자에 대한 개인정보 처리)' +
    '<br><br>' +
    '회사는 1년 동안 회사의 서비스를 이용하지 않은 이용자의 개인정보를 이용자에게 미리 공지하고 개인정보를 별도로 파기 또는 보관하는 것을 원칙으로 합니다.' +
    '<br>' +
    '1. 회사는 장기간 사용하지 않은 이용자의 개인정보를 별도로 안전하게 보관하며, 이러한 이용자의 알림은 분리 및 처리일 최소 30일 전에 해당 이용자의 이메일 주소로 발송됩니다.' +
    '<br>' +
    "2. 장기간 서비스를 이용하지 않은 이용자는 회사가 비이용자용 DB를 분리하기 전에 서비스를 계속 이용하고자 할 경우 홈페이지('모바일 앱' 포함)에 로그인할 수 있습니다." +
    '<br>' +
    '3. 장기간 서비스를 이용하지 않은 이용자는 홈페이지 로그인 시 이용자 동의 하에 계정을 복원할 수 있습니다.' +
    '<br>' +
    '4. 회사는 별도로 보관된 개인정보를 4년간 보관한 후 지체 없이 파기합니다.' +
    '<br><br><br>' +
    '제14조(개인정보 파기절차)' +
    '<br><br>' +
    '1. 회원가입 등을 위해 이용자가 입력한 정보는 개인정보처리 목적 달성 후 별도 DB로 이관되어 내부방침 및 기타 관련 법규에 따라 보관됩니다. 일정기간 보관 후 파기합니다.' +
    '<br>' +
    '2. 회사는 개인정보보호관리자의 승인 절차를 거쳐 파기사유가 있는 개인정보를 파기합니다.' +
    '<br><br><br>' +
    '제15조(개인정보의 파기방법)' +
    '<br><br>' +
    '회사는 기록을 복구할 수 없게 만드는 기술적 방법을 사용하여 전자 파일 형식으로 저장된 개인 정보를 삭제하고, 종이에 인쇄된 개인 정보는 파쇄 또는 소각하여 파기합니다.' +
    '<br><br><br>' +
    '제16조(광고정보의 전송조치)' +
    '<br><br>' +
    '1. 전자송신매체를 이용하여 상업적 목적으로 광고성 정보를 전송하는 경우 회사는 이용자의 명시적인 사전 동의를 얻습니다. 다만, 다음 각 호의 어느 하나에 해당하는 경우에는 사전 동의를 얻지 않습니다:' +
    '<br>' +
    'a. 상품 등에 대한 거래관계를 통해 수취인으로부터 직접 연락처를 수집하는 경우 거래 종료일로부터 6개월 이내에 수취인과 거래한 상품과 동일한 유형의 상품에 대한 영리광고 정보를 전송하고자 하는 경우' +
    '<br>' +
    'b. 방문판매 등에 관한 법률에 의한 전화권유판매업자가 수신자에게 개인정보수집의 출처를 알리고 전화권유를 한 경우' +
    '<br>' +
    '2. 전항에도 불구하고 수신인이 수신거부 의사를 표시하거나 사전동의를 철회하는 경우 회사는 상업적 목적으로 광고성 정보를 전송하지 않으며, 수신인에게 정보 수신거부 또는 동의 철회에 대한 처리결과를 통보할 예정입니다.' +
    '<br>' +
    '3. 제1항에도 불구하고 회사가 오후 9시부터 다음날 오전 8시 사이에 전자송신매체를 이용하여 상업적 목적의 광고성 정보를 전송하는 경우에는 수신자로부터 별도의 사전 동의를 받습니다.' +
    '<br>' +
    '4. 회사는 전자송신매체를 이용하여 상업적 목적으로 광고정보를 전송하는 경우, 광고정보에 다음과 같은 내용을 구체적으로 공시합니다:' +
    '<br>' +
    'a. 회사명 및 연락처' +
    '<br>' +
    'b. 접수거부 또는 접수동의 철회에 관한 사항의 표시' +
    '<br>' +
    '5. 전자전송매체를 이용하여 상업적 목적으로 광고성 정보를 전송하는 경우 회사는 다음 각 호의 조치를 취하지 않습니다:' +
    '<br>' +
    'a. 광고성 정보 수신자가 수신을 거부하거나 수신 동의를 철회하는 것을 피하거나 방지하기 위한 조치' +
    '<br>' +
    'b. 번호, 기호 또는 문자를 조합하여 전화번호 또는 이메일 주소 등 수신인의 연락처를 자동으로 생성하는 조치' +
    '<br>' +
    'c. 상업광고 정보의 전송을 목적으로 전화번호 또는 이메일 주소를 자동으로 등록하는 조치' +
    '<br>' +
    'd. 광고정보의 송신자 또는 광고송신원의 신원을 숨기기 위한 각종 조치' +
    '<br>' +
    'e. 상업광고 정보의 전송을 목적으로 수신자를 기망하여 대응을 유도하기 위한 각종 조치' +
    '<br><br><br>' +
    '제17조(개인정보 조회 및 수집 동의 철회)' +
    '<br><br>' +
    '1. 이용자 및 법정대리인은 언제든지 자신의 등록된 개인정보를 열람 또는 수정할 수 있으며, 개인정보 수집에 대한 동의 철회를 요청할 수 있습니다.' +
    '<br>' +
    '2. 이용자 및 법정대리인은 개인정보보호책임자 또는 담당자에게 서면, 전화, 이메일 등으로 연락하여 본인의 가입정보 수집 등에 대한 동의를 철회할 수 있으며, 회사는 지체 없이 조치를 취하게 됩니다.' +
    '<br><br><br>' +
    '제18조(개인정보 등의 변경)' +
    '<br><br>' +
    '1. 이용자는 위에서 설명한 방법을 통해 회사에 개인정보 오류 정정을 요청할 수 있습니다.' +
    '<br>' +
    '2. 전항의 경우 개인정보 정정이 완료될 때까지 개인정보를 이용하거나 제공하지 않으며, 이미 제3자에게 잘못된 개인정보를 제공한 경우에는 지체 없이 정정 결과를 제3자에게 통보하여 정정하도록 하겠습니다.' +
    '<br><br><br>' +
    '제19조(이용자 의무)' +
    '<br><br>' +
    '1. 이용자는 개인 정보를 최신 상태로 유지해야 하며, 부정확한 정보를 입력하여 발생하는 모든 문제에 대한 책임이 있습니다.' +
    '<br>' +
    '2. 타인의 개인정보를 이용하여 회원가입을 할 경우 이용자 지위를 상실하거나 관련 개인정보보호법에 따라 처벌을 받을 수 있습니다.' +
    '<br>' +
    '3. 이용자는 이메일 주소, 비밀번호 등의 보안을 유지할 책임이 있으며, 제3자에게 양도 또는 대여할 수 없습니다. 이로 인해 발생한 문제에 대해서는 회사가 책임지지 않습니다. 타인의 정보 및 존엄성을 훼손할 시에는 「개인정보 보호법」, 「정보통신망법」 등에 의해 처벌받을 수 있습니다.' +
    '<br>' +
    '4. 이용자의 개인정보는 열람, 정정, 삭제, 동의 철회, 처리정지 요청을 할 수 있습니다. 법정대리인이나 위임을 받은 대리인은 위임장, 가족관계증명서 등을 제출하여 정당한 대리인 여부를 입증해야 합니다. 다만, 법령에 특별한 규정이 있거나 법령상 의무를 다하기 위해 불가피한 경우, 다른 사람의 신체, 생명을 해할 우려가 있거나 다른 사람의 재산과 그 밖의 이익을 부당하게 침해할 우려가 있는 경우, 개인정보를 처리하지 않으면서 이용자와 약정한 서비스를 제공하지 못하는 경우로서 이용자가 그 계약의 해지 의사를 명확하게 밝히지 않은 경우에는 동의 철회, 삭제, 처리 정지가 어려울 수 있습니다.' +
    '<br><br><br>' +
    '제20조(개인정보 유출 등에 대한 조치)' +
    '<br><br>' +
    '회사는 개인정보의 분실·도난·유출(이하 "누출 등"이라 한다) 사실을 알게 된 때에는 즉시 이용자에게 다음 사항을 모두 고지하고 방송통신위원회 또는 한국인터넷진흥원에 신고할 예정입니다.' +
    '<br>' +
    '1. 유출된 개인정보 항목 등' +
    '<br>' +
    '2. 누출 등이 발생한 경우' +
    '<br>' +
    '3. 이용자가 수행할 수 있는 작업' +
    '<br>' +
    '4. 정보통신서비스 제공자 등의 대응조치' +
    '<br>' +
    '5. 이용자가 상담 등을 받을 수 있는 부서 및 연락처' +
    '<br><br><br>' +
    '제21조(개인정보 유출 등에 대한 조치의 예외)' +
    '<br><br>' +
    '회사는 전항에도 불구하고 이용자의 연락처를 알지 못하는 등 정당한 사유가 있는 경우 30일 이상 회사 홈페이지에 공지사항을 게시하여 전항에 제공된 공지사항을 대체하는 조치를 취할 수 있습니다.' +
    '<br><br><br>' +
    '제22조(쿠키 설치에 대한 이용자의 선택)' +
    '<br><br>' +
    '이용자는 쿠키를 설치할 수 있는 옵션이 있습니다. 따라서 이용자는 웹 브라우저에서 옵션을 설정하여 모든 쿠키를 허용하거나 쿠키가 저장될 때마다 확인하거나 모든 쿠키 저장을 거부할 수 있습니다. 하지만 쿠키 보관을 거부할 경우 로그인이 필요한 회사의 일부 서비스를 이용하는 데 어려움을 겪을 수 있습니다.' +
    '<br><br><br>' +
    '제23조(쿠키의 설치 권한을 명시하는 방법)' +
    '<br><br>' +
    '다음은 쿠키 설치 허용 여부를 지정하는 방법입니다:' +
    '<br>' +
    '1. [도구] 메뉴에서 [인터넷 옵션]을 선택합니다.' +
    '<br>' +
    '2. [Privacy] 탭을 클릭합니다.' +
    '<br>' +
    '3. [Advanced] 설정에서 설정할 수 있습니다.' +
    '<br><br><br>' +
    '제24조(회사의 개인정보보호책임자 지정)' +
    '<br><br>' +
    '회사는 이용자의 개인정보를 보호하고 개인정보와 관련된 민원을 처리하기 위해 관련 부서 및 개인정보보호관을 다음과 같이 지정합니다.' +
    '<br>' +
    '- 개인정보보호관' +
    '<br>' +
    'a. 이름 : 김종익' +
    '<br>' +
    'b. 전화번호 : 051-742-7777' +
    '<br>' +
    'c. 이메일 : delivered@delivered.co.kr' +
    '<br><br>' +
    '부칙' +
    '<br>' +
    '제1조 이 정책은 2023.08.01부터 시행합니다.' +
    '<br>' +
    '제2조 2025년 5월 1일부로 개인정보 처리 주체가 글로브웨이브 주식회사에서 주식회사 딜리버드로지스틱스로 변경되었습니다.',
  en:
    '<h4>Privacy Policy</h4>' +
    '<br><br>' +
    '<div>' +
    '※ As of May 1, 2025, the personal information controller has changed from Globewave Co., Ltd. to DeliveredLogistics Co., Ltd.' +
    '<br><br><br>' +
    'Article 1 (Purpose)' +
    '<br><br>' +
    'DeliveredLogistics Co., Ltd. (hereinafter "Company") protects the personal information of individuals (hereinafter "Users") who use the Company\'s services. The Company establishes this Privacy Policy to comply with the Personal Information Protection Act, the Act on Promotion of Information and Communications Network Utilization and Information Protection, and other applicable laws, and to promptly handle complaints from users related to personal information protection.' +
    '<br><br><br>' +
    'Article 2 (Principles of Personal Information Processing)' +
    '<br><br>' +
    "1. In accordance with the statutes relating to personal information and this Policy, the Company may collect a user's personal information, and collected personal information may be provided to a third party only with the individual's consent. However, where there are other statutes or regulations, such as the Personal Information Protection Act, the Network Act, the Protection of Communications Secrets Act, the Telecommunications Business Act, the Act on the Consumer Protection in Electronic Commerce, Etc., the Framework Act on National Taxes, the Credit Information Use and Protection Act, the Framework Act on Consumers, the Act on the Prevention of Suicide and the Creation of a Culture of Respect for Life, and the Framework Act on Product Safety, the Company may provide a user's personal information to a third party in accordance with the lawful procedures prescribed by such statutes. In particular, in an emergency such as a disaster, an infectious disease, an incident causing imminent danger to life or body, or imminent property loss, the Company may provide personal information to the relevant agencies without the user's consent." +
    '<br><br>' +
    '2. The Company may entrust the processing of personal information to ensure the smooth provision of services. When entrusting such processing, the Company specifies in a contract or other document, in accordance with Article 26 of the Personal Information Protection Act, matters such as the prohibition of processing personal information beyond the purpose of the entrusted work, technical and managerial protective measures, restriction on re-entrustment, supervision of the trustee, and liability for damages, and supervises whether the trustee processes personal information safely.' +
    '<br><br><br>' +
    'Article 3 (Disclosure of this Policy)' +
    '<br><br>' +
    "1. The Company discloses this Policy through the first screen or a link on the first screen of the Company's homepage so that users can easily check this Policy at any time." +
    '<br>' +
    '2. When the Company discloses this Policy, the Company uses font size, color, etc. so that users can easily check this Policy.' +
    '<br><br><br>' +
    'Article 4 (Changes to this Policy)' +
    '<br><br>' +
    '1. This Policy may be revised in accordance with changes in laws, guidelines, notices, or policies related to personal information or changes in government or Company service policies.' +
    '<br>' +
    '2. When the Company revises this Policy, the Company will announce through one or more of the following methods:' +
    '<br>' +
    "a. Posting a notice on the notice board of the first screen of the Company's homepage or announcing through a separate window." +
    '<br>' +
    'b. Notifying users by letter, facsimile, email, or similar methods.' +
    '<br>' +
    '3. The Company will announce at least 7 days before the effective date of revision of this Policy. However, in the event of significant changes to user rights, the Company will announce at least 30 days in advance.' +
    '<br><br><br>' +
    'Article 5 (Information for Membership Registration)' +
    '<br><br>' +
    "The Company collects the following information to enable users to register for the Company's services." +
    '<br>' +
    '1. Required collection information: Email address and nickname' +
    '<br><br><br>' +
    "Article 6 (Information for the Company's Service Provision)" +
    '<br><br>' +
    "The Company collects the following information to provide the Company's services to users." +
    '<br>' +
    '1. Required collection information: User ID and email address' +
    '<br><br><br>' +
    'Article 7 (Information for Confirming Service Use and Misuse)' +
    '<br><br>' +
    "The Company collects the following information to confirm and analyze users' service use and misuse." +
    '<br>' +
    '1. Required collection information: Service usage records' +
    '<br><br><br>' +
    'Article 8 (Methods of Personal Information Collection)' +
    '<br><br>' +
    "The Company collects users' personal information in the following ways." +
    '<br>' +
    "1. Methods by which users input personal information on the Company's homepage." +
    '<br>' +
    "2. Methods by which users input personal information through services other than the Company's website, such as applications." +
    '<br><br><br>' +
    'Article 9 (Use of Personal Information)' +
    '<br><br>' +
    'The Company utilizes personal information in the following cases.' +
    '<br>' +
    '1. Service improvement for users, such as responding to usage inquiries and handling complaints' +
    '<br>' +
    "2. Provision of the Company's services" +
    '<br>' +
    '3. Demographic analysis, analysis of service visits and usage records' +
    '<br>' +
    '4. To prevent and sanction acts that interfere with the smooth operation of services, such as restricting members who violate laws and company terms and conditions, and fraudulent use.' +
    '<br><br><br>' +
    'Article 10 (Retention and Use Period of Personal Information)' +
    '<br><br>' +
    "1. The Company retains and uses users' personal information for the relevant period to achieve the purposes of personal information collection and use." +
    '<br>' +
    '2. Notwithstanding the preceding paragraph, records of illegal service use are retained for up to 1 year from the time of membership withdrawal to prevent illegal registration and use.' +
    '<br><br><br>' +
    'Article 11 (Retention and Use Period of Personal Information According to Law)' +
    '<br><br>' +
    'The Company retains and uses personal information as follows in accordance with applicable laws.' +
    '<br>' +
    '1. Information and retention period pursuant to the Act on Consumer Protection in Electronic Commerce:' +
    '<br>' +
    '- Records on contracts or withdrawal of subscription: 5 years' +
    '<br>' +
    '- Records on payment of goods and supply performance: 5 years' +
    '<br>' +
    '- Records on consumer complaints or dispute resolution: 3 years' +
    '<br>' +
    '- Records on labeling and advertising: 6 months' +
    '<br>' +
    '2. Information and retention period pursuant to the Protection of Communications Secrets Act:' +
    '<br>' +
    '- Website log records: 3 months' +
    '<br>' +
    '3. Information and retention period pursuant to the Electronic Financial Transactions Act:' +
    '<br>' +
    '- Electronic financial transaction records: 5 years' +
    '<br>' +
    '4. Act on the Protection and Use of Location Information:' +
    '<br>' +
    '- Personal location information records: 6 months' +
    '<br><br><br>' +
    'Article 12 (Principles of Personal Information Destruction)' +
    '<br><br>' +
    'Personal information shall be destroyed without delay when it is no longer needed, such as when the purpose of processing has been achieved or the retention period has expired.' +
    '<br><br><br>' +
    'Article 13 (Handling of Personal Information of Non-Users)' +
    '<br><br>' +
    "As a principle, the Company notifies users in advance and separately destroys or stores the personal information of users who have not used the Company's services for 1 year." +
    '<br>' +
    "1. The Company safely stores the personal information of long-term non-users separately, and notifications to such users are sent to the user's email address at least 30 days before the separation and processing date." +
    '<br>' +
    '2. Long-term non-users may log in to the homepage (including mobile app) if they wish to continue using the service before the Company separates the non-user DB.' +
    '<br>' +
    '3. Long-term non-users may restore their accounts with user consent when logging in to the homepage.' +
    '<br>' +
    '4. The Company destroys separately stored personal information without delay after retaining it for 4 years.' +
    '<br><br><br>' +
    'Article 14 (Personal Information Destruction Procedure)' +
    '<br><br>' +
    "1. Information entered by users for membership registration is transferred to a separate DB after the purpose of personal information processing is achieved and stored in accordance with the Company's internal policies and applicable laws. It is destroyed after a certain period of storage." +
    '<br>' +
    '2. The Company destroys personal information with reasons for destruction through the approval procedure of the personal information protection manager.' +
    '<br><br><br>' +
    'Article 15 (Methods of Personal Information Destruction)' +
    '<br><br>' +
    'The Company deletes personal information stored in electronic file format using technical methods that make it impossible to recover the records, and destroys personal information printed on paper by shredding or incineration.' +
    '<br><br><br>' +
    'Article 16 (Measures for Transmission of Advertising Information)' +
    '<br><br>' +
    '1. When transmitting advertising information for commercial purposes using electronic transmission media, the Company obtains the explicit prior consent of users. However, prior consent is not required in the following cases:' +
    '<br>' +
    'a. When collecting contact information directly from the recipient through a transaction relationship and intending to transmit commercial advertising information for the same type of goods within 6 months from the date of transaction completion.' +
    '<br>' +
    'b. When a telemarketer pursuant to the Act on Door-to-Door Sales informs the recipient of the source of personal information collection and makes a telephone solicitation.' +
    '<br>' +
    '2. If the recipient expresses an intention to refuse receipt or withdraws prior consent, the Company will not transmit advertising information for commercial purposes and will notify the recipient of the processing result.' +
    '<br>' +
    '3. When transmitting commercial advertising information between 9 PM and 8 AM the next morning, the Company obtains separate prior consent from the recipient.' +
    '<br>' +
    '4. When transmitting advertising information for commercial purposes, the Company specifically discloses the following:' +
    '<br>' +
    'a. Company name and contact information' +
    '<br>' +
    'b. Matters regarding refusal to receive or withdrawal of consent to receive.' +
    '<br>' +
    '5. When transmitting advertising information, the Company does not take any of the following measures:' +
    '<br>' +
    'a. Measures to prevent recipients from refusing to receive or withdrawing consent' +
    '<br>' +
    'b. Measures to automatically generate recipient contact information by combining numbers, symbols, or letters' +
    '<br>' +
    'c. Measures to automatically register contact information for the purpose of transmitting commercial advertising information' +
    '<br>' +
    'd. Various measures to conceal the identity of the sender or source of advertising information' +
    '<br>' +
    'e. Various measures to deceive recipients to induce responses' +
    '<br><br><br>' +
    'Article 17 (Withdrawal of Consent to Personal Information Inquiry and Collection)' +
    '<br><br>' +
    '1. Users and legal representatives may view or modify their registered personal information at any time, and may request withdrawal of consent to personal information collection.' +
    '<br>' +
    '2. Users and legal representatives may withdraw consent by contacting the personal information protection officer by letter, phone, or email, and the Company will take action without delay.' +
    '<br><br><br>' +
    'Article 18 (Changes to Personal Information)' +
    '<br><br>' +
    '1. Users may request correction of personal information errors from the Company through the methods described above.' +
    '<br>' +
    '2. Personal information will not be used or provided until the correction is completed, and if incorrect personal information has already been provided to a third party, the Company will notify the third party of the correction result without delay.' +
    '<br><br><br>' +
    'Article 19 (User Obligations)' +
    '<br><br>' +
    '1. Users are responsible for keeping their personal information up to date and are responsible for all problems arising from entering inaccurate information.' +
    '<br>' +
    "2. Using another person's personal information to register as a member may result in loss of user status or punishment under applicable personal information protection laws." +
    '<br>' +
    '3. Users are responsible for maintaining the security of their email addresses, passwords, etc., and cannot transfer or lend them to third parties.' +
    '<br>' +
    "4. A user may request inspection, correction, deletion, withdrawal of consent, and suspension of processing of their personal information. A legal representative or an authorized agent must prove that they are a legitimate agent by submitting a power of attorney, a family relationship certificate, etc. However, where there are special provisions in statute, where it is unavoidable in order to fulfil a statutory obligation, where there is a risk of harm to another person's body or life or of unjustly infringing another person's property or other interests, or where the service agreed with the user cannot be provided without processing the personal information and the user has not clearly expressed an intention to terminate the contract, the withdrawal of consent, deletion, or suspension of processing may be difficult." +
    '<br><br><br>' +
    'Article 20 (Measures Against Personal Information Breach)' +
    '<br><br>' +
    'When the Company becomes aware of loss, theft, or leakage of personal information (hereinafter "Breach"), the Company will immediately notify users of all of the following and report to the Korea Communications Commission or Korea Internet & Security Agency.' +
    '<br>' +
    '1. Items of personal information that were leaked' +
    '<br>' +
    '2. When the breach occurred' +
    '<br>' +
    '3. Actions that users can take' +
    '<br>' +
    '4. Countermeasures by the Company' +
    '<br>' +
    '5. Department and contact information where users can receive consultation' +
    '<br><br><br>' +
    'Article 21 (Exceptions to Measures Against Personal Information Breach)' +
    '<br><br>' +
    "Notwithstanding the preceding paragraph, if there is a legitimate reason such as not knowing the user's contact information, the Company may take substitute measures by posting a notice on the Company's homepage for 30 days or more." +
    '<br><br><br>' +
    "Article 22 (User's Choice on Cookie Installation)" +
    '<br><br>' +
    "Users have the option to install cookies. Users may set options in their web browser to allow all cookies, confirm each time a cookie is stored, or refuse to store all cookies. However, if you refuse to store cookies, you may have difficulty using some of the Company's services that require login." +
    '<br><br><br>' +
    'Article 23 (Method of Specifying Cookie Installation Authority)' +
    '<br><br>' +
    'The following is the method for specifying whether to allow cookie installation:' +
    '<br>' +
    '1. Select [Internet Options] from the [Tools] menu.' +
    '<br>' +
    '2. Click the [Privacy] tab.' +
    '<br>' +
    '3. Settings can be made in [Advanced] settings.' +
    '<br><br><br>' +
    "Article 24 (Designation of the Company's Personal Information Protection Officer)" +
    '<br><br>' +
    "The Company designates the relevant department and personal information protection officer as follows to protect users' personal information and handle complaints related to personal information." +
    '<br>' +
    '- Personal Information Protection Officer' +
    '<br>' +
    'a. Name: Kim Jong-ik' +
    '<br>' +
    'b. Phone: 051-742-7777' +
    '<br>' +
    'c. Email: delivered@delivered.co.kr' +
    '<br><br>' +
    'Addendum' +
    '<br>' +
    'Article 1. This Policy is effective from August 1, 2023.' +
    '<br>' +
    'Article 2. As of May 1, 2025, the personal information controller has changed from Globewave Co., Ltd. to DeliveredLogistics Co., Ltd.',
  ja:
    '<h4>個人情報処理方針</h4>' +
    '<br><br>' +
    '<div>' +
    '※ 2025年5月1日付で、個人情報取扱事業者がグローブウェーブ株式会社からデリバードロジスティクス株式会社に変更されました。' +
    '<br><br><br>' +
    '第1条（目的）' +
    '<br><br>' +
    'デリバードロジスティクス株式会社（以下「当社」といいます）は、当社のサービスを利用する個人（以下「ユーザー」といいます）の個人情報を保護します。当社は、「個人情報保護法」、「情報通信網利用促進及び情報保護等に関する法律」その他の関連法令を遵守し、個人情報保護に関するユーザーの苦情を迅速に処理するため、本個人情報処理方針を制定します。' +
    '<br><br><br>' +
    '第2条（個人情報処理の原則）' +
    '<br><br>' +
    '1. 当社は、個人情報に関連する法令および本方針に従い、ユーザーの個人情報を収集することができ、収集した個人情報は本人の同意がある場合に限り第三者に提供することができます。ただし、「個人情報保護法」、「情報通信網法」、「通信秘密保護法」、「電気通信事業法」、「電子商取引等における消費者保護に関する法律」、「国税基本法」、「信用情報の利用および保護に関する法律」、「消費者基本法」、「自殺予防および生命尊重文化の造成のための法律」、「製品安全基本法」など他の法令に規定がある場合、当社は当該法令に定める適法な手続に従い、ユーザーの個人情報を第三者に提供することができます。特に、災害、感染症、生命または身体への急迫な危険を引き起こす事件・事故、急迫な財産上の損失など緊急の状況においては、当社はユーザーの同意なく関係機関に個人情報を提供することがあります。' +
    '<br><br>' +
    '2. 当社は、サービスの円滑な提供のため、個人情報の処理を委託することができます。委託にあたっては、「個人情報保護法」第26条に従い、委託業務の目的を超えた個人情報の処理の禁止、技術的・管理的保護措置、再委託の制限、受託者の監督、損害賠償責任等に関する事項を契約書その他の文書に明記し、受託者が個人情報を安全に処理しているかを監督します。' +
    '<br><br><br>' +
    '第3条（本方針の公開）' +
    '<br><br>' +
    '1. 当社は、ユーザーがいつでも容易に本方針を確認できるよう、当社ホームページの最初の画面または最初の画面とのリンクを通じて本方針を公開します。' +
    '<br>' +
    '2. 当社は、本方針を公開する際に、ユーザーが容易に本方針を確認できるよう、文字の大きさ、色等を工夫します。' +
    '<br><br><br>' +
    '第4条（本方針の変更）' +
    '<br><br>' +
    '1. 本方針は、個人情報に関連する法令、ガイドライン、告示もしくは方針の変更、または政府もしくは当社のサービス方針の変更に応じて改定されることがあります。' +
    '<br>' +
    '2. 当社が本方針を改定する場合は、次のいずれかの方法によりお知らせします。' +
    '<br>' +
    'a. 当社ホームページの最初の画面のお知らせ欄に掲示し、または別ウィンドウで告知する方法。' +
    '<br>' +
    'b. 書面、ファックス、電子メールその他類似の方法によりユーザーに通知する方法。' +
    '<br>' +
    '3. 当社は、本方針の改定の効力発生日の少なくとも7日前までに告知します。ただし、ユーザーの権利に関する重要な変更がある場合は、少なくとも30日前までに告知します。' +
    '<br><br><br>' +
    '第5条（会員登録のための情報）' +
    '<br><br>' +
    '当社は、ユーザーが当社サービスに会員登録できるようにするため、次の情報を収集します。' +
    '<br>' +
    '1. 必須収集情報：メールアドレスおよびニックネーム' +
    '<br><br><br>' +
    '第6条（当社サービス提供のための情報）' +
    '<br><br>' +
    '当社は、ユーザーに当社のサービスを提供するため、次の情報を収集します。' +
    '<br>' +
    '1. 必須収集情報：ユーザーIDおよびメールアドレス' +
    '<br><br><br>' +
    '第7条（サービス利用および不正利用確認のための情報）' +
    '<br><br>' +
    '当社は、ユーザーのサービス利用および不正利用を確認・分析するため、次の情報を収集します。' +
    '<br>' +
    '1. 必須収集情報：サービス利用記録' +
    '<br><br><br>' +
    '第8条（個人情報の収集方法）' +
    '<br><br>' +
    '当社は、次の方法によりユーザーの個人情報を収集します。' +
    '<br>' +
    '1. ユーザーが当社ホームページにおいて個人情報を入力する方法。' +
    '<br>' +
    '2. ユーザーがアプリケーション等、当社のウェブサイト以外のサービスを通じて個人情報を入力する方法。' +
    '<br><br><br>' +
    '第9条（個人情報の利用）' +
    '<br><br>' +
    '当社は、次の場合に個人情報を利用します。' +
    '<br>' +
    '1. 利用に関する問い合わせへの対応、苦情処理など、ユーザーのためのサービス改善' +
    '<br>' +
    '2. 当社サービスの提供' +
    '<br>' +
    '3. 人口統計分析、サービス訪問および利用記録の分析' +
    '<br>' +
    '4. 法令および当社規約に違反する会員に対する利用制限、不正利用など、サービスの円滑な運営を妨げる行為の防止および制裁' +
    '<br><br><br>' +
    '第10条（個人情報の保有および利用期間）' +
    '<br><br>' +
    '1. 当社は、個人情報の収集および利用の目的を達成するために必要な期間、ユーザーの個人情報を保有および利用します。' +
    '<br>' +
    '2. 前項にかかわらず、不正利用の記録については、不正な登録および利用を防止するため、会員退会時から最長1年間保有します。' +
    '<br><br><br>' +
    '第11条（法令による個人情報の保有および利用期間）' +
    '<br><br>' +
    '当社は、関連法令に従い、次のとおり個人情報を保有および利用します。' +
    '<br>' +
    '1. 「電子商取引等における消費者保護に関する法律」に基づく情報および保有期間：' +
    '<br>' +
    '- 契約または申込みの撤回等に関する記録：5年' +
    '<br>' +
    '- 代金決済および財貨等の供給に関する記録：5年' +
    '<br>' +
    '- 消費者の苦情または紛争処理に関する記録：3年' +
    '<br>' +
    '- 表示・広告に関する記録：6か月' +
    '<br>' +
    '2. 「通信秘密保護法」に基づく情報および保有期間：' +
    '<br>' +
    '- ウェブサイト訪問記録（ログ記録）：3か月' +
    '<br>' +
    '3. 「電子金融取引法」に基づく情報および保有期間：' +
    '<br>' +
    '- 電子金融取引に関する記録：5年' +
    '<br>' +
    '4. 「位置情報の保護および利用等に関する法律」：' +
    '<br>' +
    '- 個人位置情報に関する記録：6か月' +
    '<br><br><br>' +
    '第12条（個人情報破棄の原則）' +
    '<br><br>' +
    '個人情報は、処理目的が達成された場合、保有期間が経過した場合など、不要となった場合には遅滞なく破棄します。' +
    '<br><br><br>' +
    '第13条（休眠会員の個人情報の取扱い）' +
    '<br><br>' +
    '当社は、原則として、当社のサービスを1年間利用しなかったユーザーに対し、事前に通知のうえ、その個人情報を別途分離保管または破棄します。' +
    '<br>' +
    '1. 当社は、長期未利用者の個人情報を安全に分離保管し、当該ユーザーへの通知は、分離処理日の少なくとも30日前までに当該ユーザーのメールアドレス宛てに送付します。' +
    '<br>' +
    '2. 長期未利用者は、当社が休眠DBへ分離する前に、引き続きサービスの利用を希望する場合、ホームページ（モバイルアプリを含む）にログインすることができます。' +
    '<br>' +
    '3. 長期未利用者は、ホームページへのログイン時に、ユーザーの同意のもとアカウントを復元することができます。' +
    '<br>' +
    '4. 当社は、分離保管した個人情報を4年間保有した後、遅滞なく破棄します。' +
    '<br><br><br>' +
    '第14条（個人情報破棄の手続）' +
    '<br><br>' +
    '1. ユーザーが会員登録のために入力した情報は、個人情報の処理目的が達成された後、当社の内部方針および関連法令に従い、別途のDBに移して保管します。一定期間保管した後に破棄します。' +
    '<br>' +
    '2. 当社は、破棄事由が発生した個人情報を、個人情報保護責任者の承認手続を経て破棄します。' +
    '<br><br><br>' +
    '第15条（個人情報破棄の方法）' +
    '<br><br>' +
    '当社は、電子的ファイル形式で保管された個人情報については、記録を復元できない技術的方法を用いて削除し、紙に印刷された個人情報については、シュレッダーによる裁断または焼却により破棄します。' +
    '<br><br><br>' +
    '第16条（広告情報送信の措置）' +
    '<br><br>' +
    '1. 当社は、電子的送信媒体を利用して営利目的の広告情報を送信する場合、ユーザーの明示的な事前同意を得ます。ただし、次の場合は事前同意を要しません：' +
    '<br>' +
    'a. 受信者との取引関係を通じて直接連絡先を収集し、取引終了日から6か月以内に受信者と取引した財貨等と同種の財貨等に関する営利目的の広告情報を送信しようとする場合。' +
    '<br>' +
    'b. 「訪問販売等に関する法律」に基づく電話勧誘販売者が、個人情報の収集出所を受信者に告知し、電話による勧誘を行う場合。' +
    '<br>' +
    '2. 受信者が受信拒否の意思を表示し、または事前同意を撤回した場合、当社は営利目的の広告情報を送信せず、処理結果を受信者に通知します。' +
    '<br>' +
    '3. 当社は、午後9時から翌日午前8時までの間に営利目的の広告情報を送信する場合、受信者から別途の事前同意を得ます。' +
    '<br>' +
    '4. 当社は、営利目的の広告情報を送信する場合、次の事項を具体的に明示します：' +
    '<br>' +
    'a. 当社の名称および連絡先' +
    '<br>' +
    'b. 受信拒否または受信同意の撤回に関する事項。' +
    '<br>' +
    '5. 当社は、広告情報を送信するにあたり、次のいずれの措置も行いません：' +
    '<br>' +
    'a. 受信者の受信拒否または受信同意の撤回を妨げる措置' +
    '<br>' +
    'b. 数字、記号または文字を組み合わせて受信者の連絡先を自動的に生成する措置' +
    '<br>' +
    'c. 営利目的の広告情報送信のために連絡先を自動的に登録する措置' +
    '<br>' +
    'd. 広告情報の送信者または送信元の身元を隠ぺいする各種の措置' +
    '<br>' +
    'e. 受信者を欺罔して回答を誘発する各種の措置' +
    '<br><br><br>' +
    '第17条（個人情報の閲覧および収集同意の撤回）' +
    '<br><br>' +
    '1. ユーザーおよび法定代理人は、いつでも登録された個人情報を閲覧または修正することができ、個人情報の収集同意の撤回を請求することができます。' +
    '<br>' +
    '2. ユーザーおよび法定代理人は、書面、電話または電子メールにより個人情報保護責任者に連絡することで同意の撤回を行うことができ、当社は遅滞なく必要な措置を行います。' +
    '<br><br><br>' +
    '第18条（個人情報の変更）' +
    '<br><br>' +
    '1. ユーザーは、上記の方法により、当社に対して個人情報の誤りの訂正を請求することができます。' +
    '<br>' +
    '2. 訂正が完了するまで当該個人情報は利用または提供されず、誤った個人情報が既に第三者に提供されている場合、当社は遅滞なく訂正結果を第三者に通知します。' +
    '<br><br><br>' +
    '第19条（ユーザーの義務）' +
    '<br><br>' +
    '1. ユーザーは、自己の個人情報を最新の状態に保つ責任を負い、不正確な情報の入力により生じた問題について、すべての責任を負います。' +
    '<br>' +
    '2. 他人の個人情報を利用して会員登録を行った場合、ユーザー資格を喪失し、または関連する個人情報保護法令により処罰される場合があります。' +
    '<br>' +
    '3. ユーザーは、自己のメールアドレス、パスワード等の安全性の維持について責任を負い、これを第三者に譲渡し、または貸与することはできません。' +
    '<br>' +
    '4. ユーザーは、自己の個人情報について、閲覧、訂正、削除、同意の撤回および処理停止を請求することができます。法定代理人または受任者は、委任状、家族関係証明書等を提出して正当な代理人であることを証明しなければなりません。ただし、法令に特別の定めがある場合、法令上の義務の履行のためにやむを得ない場合、他人の生命・身体を害するおそれがあり、もしくは他人の財産その他の利益を不当に侵害するおそれがある場合、または当該個人情報を処理しなければユーザーと約定したサービスを提供できず、ユーザーが契約解除の意思を明確に表示していない場合には、同意の撤回、削除または処理停止が困難となることがあります。' +
    '<br><br><br>' +
    '第20条（個人情報漏えい等への対応措置）' +
    '<br><br>' +
    '当社は、個人情報の紛失、盗難または漏えい（以下「漏えい等」といいます）を認知した場合、直ちに次の事項のすべてをユーザーに通知し、放送通信委員会または韓国インターネット振興院に申告します。' +
    '<br>' +
    '1. 漏えい等が発生した個人情報の項目' +
    '<br>' +
    '2. 漏えい等が発生した時点' +
    '<br>' +
    '3. ユーザーが取りうる措置' +
    '<br>' +
    '4. 当社の対応措置' +
    '<br>' +
    '5. ユーザーが相談を受けることができる部署および連絡先' +
    '<br><br><br>' +
    '第21条（個人情報漏えい等への対応措置の例外）' +
    '<br><br>' +
    '前項にかかわらず、ユーザーの連絡先を知らない等の正当な事由がある場合、当社は、自社のホームページに30日以上掲示する方法により、これに代わる措置を講ずることができます。' +
    '<br><br><br>' +
    '第22条（クッキー設置に関するユーザーの選択権）' +
    '<br><br>' +
    'ユーザーには、クッキーの設置に関する選択権があります。ユーザーは、ウェブブラウザのオプションを設定することにより、すべてのクッキーを許可し、クッキーの保存時に都度確認し、またはすべてのクッキーの保存を拒否することができます。ただし、クッキーの保存を拒否した場合、ログインを必要とする当社の一部サービスの利用に支障が生じる場合があります。' +
    '<br><br><br>' +
    '第23条（クッキー設置の許可指定方法）' +
    '<br><br>' +
    'クッキーの設置を許可するか否かを指定する方法は次のとおりです：' +
    '<br>' +
    '1. ［ツール］メニューから［インターネットオプション］を選択します。' +
    '<br>' +
    '2. ［プライバシー］タブをクリックします。' +
    '<br>' +
    '3. ［詳細設定］で設定を行うことができます。' +
    '<br><br><br>' +
    '第24条（当社の個人情報保護責任者の指定）' +
    '<br><br>' +
    '当社は、ユーザーの個人情報を保護し、個人情報に関する苦情を処理するため、次のとおり関連部署および個人情報保護責任者を指定します。' +
    '<br>' +
    '- 個人情報保護責任者' +
    '<br>' +
    'a. 氏名：キム・ジョンイク' +
    '<br>' +
    'b. 電話番号：051-742-7777' +
    '<br>' +
    'c. メール：delivered@delivered.co.kr' +
    '<br><br>' +
    '附則' +
    '<br>' +
    '第1条 本方針は2023年8月1日より施行します。' +
    '<br>' +
    '第2条 2025年5月1日付で、個人情報取扱事業者がグローブウェーブ株式会社からデリバードロジスティクス株式会社に変更されました。',
};

const refundTerm = {
  ko:
    '<h4>환불 정책</h4>' +
    '<div>' +
    '<br/><br/>- 구매한 상품의 유효기간은 구매 후 1년입니다.<br/><br/>- 유효기간은 구매내역을 통해 확인하실 수 있습니다.<br/><br/>- 유료 결제 후 7일 이내에 환불하는 경우 고객센터로 문의하여 본인인증 확인 후 환불 수수료(환불금액의 10%)를 제외한 금액만큼 환불 처리 가능하며, 구매 시점 7일 이후에는 환불이 불가능합니다.<br/><br/>- 인앱결제로 구매한 상품의 취소는 각 Google Play, Apple, ONE store 고객센터를 통해서 구매 취소할 수 있습니다.<br/><br/>- 만 14세 미만의 유저가 유료서비스를 이용하는 경우, 법정대리인이 동의하지 않으면 미성년자 본인 또는 법정대리인이 이용 계약을 취소할 수 있습니다. (한국에서만)<br/><br/>- 기타 문의 사항 및 궁금하신 점은 고객센터로 문의 또는 이용약관에서 확인할 수 있습니다.' +
    '</div>',
  en:
    '<h4>Refund Policy</h4>' +
    '<div>' +
    '<br/><br/>- The validity period of purchased goods is 1 year after purchase.<br/><br/>- The validity period can be confirmed through the purchase history.<br/><br/>- If you request a refund within 7 days after payment, please contact the customer center. After identity verification, a refund can be processed minus the refund fee (10% of the refund amount). Refunds are not possible after 7 days from the purchase date.<br/><br/>- Cancellation of products purchased through in-app payment can be processed through each Google Play, Apple, or ONE store customer center.<br/><br/>- If a user under 14 years of age uses paid services, the minor or legal guardian may cancel the service agreement if the legal guardian has not consented. (Korea only)<br/><br/>- For other inquiries, please contact the customer center or refer to the Terms and Conditions of Use.' +
    '</div>',
  ja:
    '<h4>返金ポリシー</h4>' +
    '<div>' +
    '<br/><br/>- 購入した商品の有効期限は購入後1年間です。<br/><br/>- 有効期限は購入履歴からご確認いただけます。<br/><br/>- 有料決済後7日以内に返金をご希望の場合は、カスタマーセンターまでお問い合わせください。本人確認後、返金手数料（返金額の10%）を差し引いた金額で返金処理が可能です。購入日から7日を経過した場合、返金はできません。<br/><br/>- アプリ内決済（インアップ決済）で購入された商品のキャンセルは、各Google Play、Apple、ONE storeのカスタマーセンターを通じて行ってください。<br/><br/>- 満14歳未満のユーザーが有料サービスを利用する場合、法定代理人が同意しなければ、未成年者本人または法定代理人が利用契約を取り消すことができます。（韓国のみ）<br/><br/>- その他のお問い合わせやご不明な点については、カスタマーセンターまでお問い合わせいただくか、利用規約をご参照ください。' +
    '</div>',
};

const specialLaw = {
  ja:
    '<div>' +
    '1. 販売業者 : Globewave Co., Ltd' +
    '<br />' +
    '2. 運営責任者 : Taehoon Kang' +
    '<br />' +
    '3. 所在地 : 1304ho, 48, Centum jungang-ro, Haeundae-gu, Busan, Republic of Korea' +
    '<br />' +
    '4. サポート : 電話、またはメールにてサポート' +
    '<br />' +
    '電話番号 : 05068835433' +
    '<br />' +
    '6. 電話受付時間 : 10:00-18:00（土日祝を除く） ※受付時間外の場合は、メールにてお問い合わせください。' +
    '<br />' +
    '7. メールアドレス : <a href="mailto:store@giftifan.com">store@giftifan.com</a>' +
    '<br />' +
    '8. サイトURL : <a href="https://www.giftifan.com">https://www.giftifan.com</a>' +
    '<br />' +
    '9. 商品の販売価格 : 各商品ページをご参照ください。' +
    '<br />' +
    '10. 商品代金以外に必要な料金 : ・送料 : 商品の重量に応じて送料が計算され、商品購入時に一緒にお支払いいただきます。 ・振込手数料およびその他の決済手数料 : 購入者様のご負担となります。' +
    '<br />' +
    '11. 支払方法 : クレジットカード決済・コンビニ決済・銀行振込 (全て前払いのみとさせて頂いております。)' +
    '<br />' +
    '12. 支払期限 : ・クレジットカード決済 : 商品注文時にお支払いが確定します。 ・コンビニ決済・銀行振込 : 注文後1日以内にお支払いください。 ・銀行振込、郵便振込 : OOOO事務局にて確認及び入金を処理した時点 ・クレジット : 登録完了後に、即時〜3時間程度で引き渡し' +
    '<br />' +
    '13. 返品・交換 : 商品到着後 7日以内に限り返品・交換が可能です。' +
    '<br />' +
    '14. 返品送料 : ・商品に欠陥がある場合 : 当方負担 ・お客様のご都合による返品・交換の場合 : お客様負担' +
    '<br />' +
    '15. その他の条件 : 利用規約をご参照ください。' +
    '<br/>' +
    '16. 配送について :' +
    '<div style="padding-left: 1rem">16.1. 海外配送方法 : 株式会社グローブウェーブ物流センターからの直接配送（郵便局EMS）<br/>' +
    '16.2. 配送地域 : グローバル配送（配送できない地域についてはCSチームにお問い合わせください。）<br/>' +
    '16.3. 配送期間 : 決済後5〜10営業日以内<br/><div style="padding-left: 2rem">16.3.1. 予約販売の場合は、配送開始日から5〜10営業日以内。 <br/>' +
    '16.3.2. 商品の在庫状況により、配送期間が多少遅れる場合があります。 <br/>' +
    '16.3.3. 物流センターの都合により、配送が遅れることがあります。<br/>' +
    ' 16.3.4. 予約販売商品など、当日配送が難しい商品を一緒に購入する場合、すべての商品が配送可能な状態になった時点でご注文いただいた商品が一緒に配送されます。 <br/>' +
    '16.3.5. 商品ごとの配送スケジュールが異なるため、詳細なスケジュールについては商品詳細ページをご参照ください。 <br/>' +
    '16.3.6. 基本の配送期間を超える時間がかかる商品や品切れの商品については、個別にご連絡いたします。</div></div>' +
    '</div>',
};

export const termsData = {
  service: {
    ko: serviceTerm.ko,
    en: serviceTerm.en,
    ja: serviceTerm.ja,
  },
  privacy: {
    ko: privacyTerm.ko,
    en: privacyTerm.en,
    ja: privacyTerm.ja,
  },
  refund: {
    ko: refundTerm.ko,
    en: refundTerm.en,
    ja: refundTerm.ja,
  },
  specialLaw: {
    ja: specialLaw.ja,
  },
};
